import React, { useEffect, useState, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './EnhancedSubDashboard.module.css'
import moment from "moment";
import BarChart from './BarChart';
import PieChart from './PieChart';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { axiosPrivateInstance } from '../../axios';
import MapView from './MapView';
import { useTranslation } from 'react-i18next';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as XLSX from 'xlsx';








function EnhancedSubDashboard({ data, files, selectedProject, selectedNamespace }) {
    //    console.log(files);
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
    };
    const [isMapTypeSelected, setIsMapTypeSelected] = useState(false);
    const [mapType, setMapType] = useState("-1");
    const [path, setPath] = useState("");
    const [fileNames, setFileNames] = useState([]);
    const [partialPath, setPartialPath] = useState("");
    const [sp, setSp] = useState(selectedProject);
    const [allDoorFeatures, setAllDoorFeatures] = useState([]);
    const [allWallFeatures, setAllWallFeatures] = useState([]);
    const [allPoleFeatures, setAllPoleFeatures] = useState([]);
    const [notMountedDoors, setNotMountedDoors] = useState([]);
    const [willBeMountedDoors, setWillBeMountedDoors] = useState([]);
    const [editedDoors, setEditedDoors] = useState([]);
    const [mountedDoors, setMountedDoors] = useState([]);
    const [notMountedPoles, setNotMountedPoles] = useState([]);
    const [willBeMountedPoles, setWillBeMountedPoles] = useState([]);
    const [editedPoles, setEditedPoles] = useState([]);
    const [mountedPoles, setMountedPoles] = useState([]);
    const [notMountedWalls, setNotMountedWalls] = useState([]);
    const [willBeMountedWalls, setWillBeMountedWalls] = useState([]);
    const [editedWalls, setEditedWalls] = useState([]);
    const [mountedWalls, setMountedWalls] = useState([]);
    const [grouppedDoorMountagesWrtDate, setGrouppedDoorMountageWrtDate] = useState();
    const [grouppedWallMountagesWrtDate, setGrouppedWallMountageWrtDate] = useState();
    const [grouppedPoleMountagesWrtDate, setGrouppedPoleMountageWrtDate] = useState();
    const [grouppedPlaquesMurales, setGrouppedPlaquesMurales] = useState();
    const [grouppedPlaquesPoteau, setGrouppedPlaquesPoteau] = useState();
    const [grouppedPoteau, setGrouppedPoteau] = useState();


    const [newMapOrGraph, setNewMapOrGraph] = useState("-1");
    const [newIsMapOrGraphSelected, setNewIsMapOrGraphSelected] = useState(false);
    const [bigDataModeForDropdown, setBigDataModeForDropdown] = useState(false);
    const [bigDataModeForCheckBox, setBigDataModeForCheckBox] = useState(false);
    const [numberOfMountedDoorYest, setNumberOfMountedDoorYest] = useState(0);
    const [numberOfMountedDoorTod, setNumberOfMountedDoorTod] = useState(0);
    const [numberOfEditedDoorYest, setNumberOfEditedDoorYest] = useState(0);
    const [numberOfEditedDoorTod, setNumberOfEditedDoorTod] = useState(0);
    const [numberOfMountedPoleYest, setNumberOfMountedPoleYest] = useState(0);
    const [numberOfMountedPoleTod, setNumberOfMountedPoleTod] = useState(0);
    const [numberOfMountedWallYest, setNumberOfMountedWallYest] = useState(0);
    const [numberOfMountedWallTod, setNumberOfMountedWallTod] = useState(0);
    const [plaquesMuralesTod, setPlaquesMuralesTod] = useState(0);
    const [plaquesMuralesYest, setPlaquesMuralesYest] = useState(0);
    const [plaquesPoteauTod, setPlaquesPoteauTod] = useState(0);
    const [plaquesPoteauYest, setPlaquesPoteauYest] = useState(0);
    const [poteauTod, setPoteauTod] = useState(0);
    const [poteauYest, setPoteauYest] = useState(0);
    const [graphForm, setGraphForm] = useState("-1");
    const [graphData, setGraphData] = useState([]);
    const [graphCaption, setGraphCaption] = useState("");
    const [docType, setDocType] = useState("");
    const [isDocTypeSelected, setIsDocTypeSelected] = useState(false);
    const [selectedRecords, setSelectedRecords] = useState([]);
    const [propertiesOfSelectedRecords, setPropertiesOfSelectedRecords] = useState([]);
    const [featuresOfSelectedRecords, setFeaturesOfSelectedFeatures] = useState([]);
    const [filterValue, setFilterValue] = useState("");
    const [filterValueForStaff, setFilterValueForStaff] = useState("");
    const [filteredRecords, setFilteredRecords] = useState([]);
    const [isFilteredByMountageState, setisFilteredByMountageState] = useState(false);
    const [isFilteredByStaff, setIsFilteredByStaff] = useState(false);
    const [filterWrtMountageState, setFilterWrtMountageState] = useState(-1);
    const [filterWrtStaff, setFilterWrtStaff] = useState(-1);
    const [stuffForSelectedRecords, setStuffForSelectedRecords] = useState([]);
    const [areas, setAreas] = useState([]);
    const [areaValue, setAreaValue] = useState("-1");
    const [isFilteredByArea, setIsFilteredByArea] = useState(false);
    const [temp, setTemp] = useState([]);
    const [anotherTemp, setAnotherTemp] = useState([]);
    const [filteredMountageRecords, setFilteredMountageRecords] = useState([]);
    const [filteredStaffRecords, setFilteredStaffRecords] = useState([]);
    const [filteredAreaRecords, setFilteredAreaRecords] = useState([]);
    const [filteredDateRecords, setFilteredDateRecords] = useState([]);
    const [isFilteredByDate, setIsFilteredByDate] = useState(false);
    const [arrayBox, setArrayBox] = useState([]);
    const [firstDate, setFirstDate] = useState("");
    const [secondDate, setSecondDate] = useState("");
    const [dateIntervalArray, setDateIntervalArray] = useState([]);
    const [computedDocType, setComputedDocType] = useState("");
    const [mapHtmlContent, setMapHtmlContent] = useState("");
    const [geoData, setGeoData] = useState("");
    const [resetGeoData, setResetGeoData] = useState("");
    const [showCanvas, setShowCanvas] = useState(false);
    const [allOfItemsOfData, setAllOfItemsOfData] = useState(data);
    const [notFoundItems, setNotFoundItems] = useState([]);
    const [computedAllOfItemsOfData, setComputedAllOfItemsOfData] = useState([]);
    const [showFrenchItems, setShowFrenchItems] = useState(false);
    //plaques_murales
    //plaques_poteau
    //poteau
    const [plaquesMurales, setPlaquesMurales] = useState([]);
    const [mountedPlaquesMurales, setMountedPlaquesMurales] = useState([]);
    const [willBeMountedPlaquesMurales, setWillBeMountedPlaquesMurales] = useState([]);
    const [notMountedPlaquesMurales, setNotMountedPlaquesMurales] = useState([]);
    const [editedPlaquesMurales, setEditedPlaquesMurales] = useState([]);


    const [plaquesPoteau, setPlaquesPoteau] = useState([]);
    const [mountedPlaquesPoteau, setMountedPlaquesPoteau] = useState([]);
    const [willBeMountedPlaquesPoteau, setWillBeMountedPlaquesPoteau] = useState([]);
    const [notMountedPlaquesPoteau, setNotMountedPlaquesPoteau] = useState([]);
    const [editedPlaquesPoteau, setEditedPlaquesPoteau] = useState([]);




    const [poteau, setPoteau] = useState([]);
    const [mountedPoteau, setMountedPoteau] = useState([]);
    const [willBeMountedPoteau, setWillBeMountedPoteau] = useState([]);
    const [notMountedPoteau, setNotMountedPoteau] = useState([]);
    const [editedPoteau, setEditedPoteau] = useState([]);
    const [mapDataForSelectedRecords, setMapDataForSelectedRecords] = useState("");
    const [resetMapDataForSelectedRecords, setResetMapDataForSelectedRecords] = useState("");

    const [showFilteredRecordsOnMapCheck, setShowFilteredRecordsOnMapCheck] = useState(false);
    const [showFiltereRecordsOnMap, setShowFilteredRecordsOnMap] = useState(false);

    const [compressedGeoJsonData, setCompressedGeoJsonData] = useState("");
    const [compressedMapDataForFilter, setCompressedMapDataForFilter] = useState("");
    const [notificationForLoadingOfMapData, setNotificationForLoadingMapData] = useState("");
    //filteredMountageRecords, filteredStuffRecords, filteredAreaRecords
    const [filterConditionsAsJson, setFilterConditionsAsJson] = useState({});
    const [performAdvancedFiltering, setPerformAdvancedFiltering] = useState(false);

    const [newFilteredRecords, setNewFilteredRecords] = useState([]);
    const [newMountageState, setNewMountageState] = useState(-1);
    const [newStaffValue, setNewStaffValue] = useState(-1);
    const [newAreaValue, setNewAreaValue] = useState(-1);
    const [newFirstDate, setNewFirstDate] = useState("");
    const [newSecondDate, setNewSecondDate] = useState("");
    const [newFilteredData, setNewFilteredData] = useState({});
    const [newFilteredFeatures, setNewFilteredFeatures] = useState({});
    const [isFilterGroupDisabled, setIsFilterGroupDisabled] = useState(false);
    const [conditions, setConditions] = useState({});
    const [ableToFilterWrtDate, setAbleToFilterWrtDate] = useState(false);
    const [filterNotification, setFilterNotification] = useState({
        content: "",
        visible: false,
        status: ""
    });

    const [mapNotification, setMapNotification] = useState({
        content: "",
        status: "",
        visible: false
    });




    useEffect(() => {
        if (filterNotification.visible) {
            const timer = setTimeout(() => {
                setFilterNotification(prev => ({
                    ...prev,
                    visible: false
                }));
            }, 5000); // 5 saniye (5000 ms)

            return () => clearTimeout(timer); // Temizlik fonksiyonu
        }
    }, [filterNotification.visible]);


    /*
setFilteredRecords(selectedRecords.filter(item => item.properties.MONTAJDURUM === String(filterValue)));
setFilteredRecords(propertiesOfSelectedRecords.filter(item => item.MONTAJYAPAN = filterValueForStaff));
setFilteredRecords(propertiesOfSelectedRecords.filter(item => item.MAHALLE = areaValue));
*/

    /*
        const parseMountageState = (n) => {
            if (n === "1" || n == null) {
                return t('willBeMounted');
            }
            else if (n === "2") {
                return t('mounted');
            }
            else if (n === "3") {
                return t('notMounted');
            }
        }
    */



    const parseMountageState = (n) => {
        if (n == "1" || n == null) {
            return t('willBeMounted');
        }
        else if (n == "2" || n == "4") {
            return t('mounted');
        }
        else if (n == "3") {
            return t('notMounted');
        }

    };

    const parseStaffValue = (n) => {
        if (n == "-1")
            return "";
        else
            return n;
    }

    const parseAreaValue = (n) => {
        if (n == "-1")
            return "";
        else
            return n;

    }








    useEffect(() => {
        console.log("data in EnhancedSubDashboard.js");
        console.log(data);
    }, [data]);


    /*
        useEffect(() => {
            console.log('data on mount:', data);
    
            // Check if KAPI.gpkg exists in the data array
            let kapiFound = false;
            let allOfItemsOfDataArr = [];
            for (let i = 0; i < data.length; i++) {
                allOfItemsOfDataArr.push(data[i]);
                if (data[i].fileName === "DUVAR_TABELA.gpkg" && data[i].data.data.DUVAR_TABELA.features) {
                    setAllWallFeatures(data[i].data.data.DUVAR_TABELA.features);
                } else if (data[i].fileName === "KAPI.gpkg" && data[i].data.data.KAPI.features) {
                    setAllDoorFeatures(data[i].data.data.KAPI.features);
                    kapiFound = true; // Mark KAPI as found
                } else if (data[i].fileName === "DIREK.gpkg" && data[i].data.data.DIREK.features) {
                    setAllPoleFeatures(data[i].data.data.DIREK.features);
                }
            }
    
            // Optionally handle cases where KAPI.gpkg is not found
            if (!kapiFound) {
                console.log('KAPI.gpkg not found in data');
            }
    
        }, [data]);
    */
    useEffect(() => {
        setComputedAllOfItemsOfData(allOfItemsOfData);
        if (files.files && allOfItemsOfData && Math.abs(files.files.length - allOfItemsOfData.length) > 0 && Math.abs(files.files.length - allOfItemsOfData.length) < 3) {
            //console.log(`${Math.abs(files.files.length - allOfItemsOfData.length)} adet dosya eksik, hangisi olduğunu bul, o dosyanın içeriğini allOfItemsOfData state'ine ekle...`);
            /*console.log("files");
            console.log(files);
            console.log("allOfItemsOfData");
            console.log(allOfItemsOfData);*/
            const arrayOfFiles = files.files;
            let arrayOfAllOfItems = [];
            for (let i = 0; i < allOfItemsOfData.length; i++) {
                arrayOfAllOfItems.push(allOfItemsOfData[i].fileName);
            }
            arrayOfFiles.filter(element => !arrayOfAllOfItems.includes(element)).map(item => {
                setNotFoundItems([...notFoundItems, item]);
            })
        }

    }, [allOfItemsOfData])



    useEffect(() => {

        if (files.files && computedAllOfItemsOfData && Math.abs(computedAllOfItemsOfData.length - files.files.length) < 3) {
            for (let i = 0; i < computedAllOfItemsOfData.length; i++) {
                if (computedAllOfItemsOfData[i].fileName === "KAPI.gpkg" || (computedAllOfItemsOfData[i].fileName === "KAPI_NO.gpkg") || (computedAllOfItemsOfData[i].fileName === "KAPINO.gpkg")) {
                    if (computedAllOfItemsOfData[i].data.data.KAPI) {
                        setAllDoorFeatures(computedAllOfItemsOfData[i].data.data.KAPI.features);
                    }
                    else if (computedAllOfItemsOfData[i].data.data.KAPI_NO) {
                        setAllDoorFeatures(computedAllOfItemsOfData[i].data.data.KAPI_NO.features);
                    }
                    else if (computedAllOfItemsOfData[i].data.data.KAPINO) {
                        setAllDoorFeatures(computedAllOfItemsOfData[i].data.data.KAPINO.features);
                    }
                }
                else if (computedAllOfItemsOfData[i].fileName === "DIREK.gpkg" || computedAllOfItemsOfData[i].fileName === "Direk.gpkg" || computedAllOfItemsOfData[i].fileName === "DİREK.gpkg" || computedAllOfItemsOfData[i].fileName === "DİREK_PLAKASI.gpkg") {
                    //console.log("DIREK");
                    if (computedAllOfItemsOfData[i].data.data.DIREK) {
                        setAllPoleFeatures(computedAllOfItemsOfData[i].data.data.DIREK.features);
                    }
                    else if (computedAllOfItemsOfData[i].data.data.DİREK) {
                        setAllPoleFeatures(computedAllOfItemsOfData[i].data.data.DİREK.features);
                    }
                    else if (computedAllOfItemsOfData[i].data.data.DİREK_PLAKASI) {
                        setAllPoleFeatures(computedAllOfItemsOfData[i].data.data.DİREK_PLAKASI.features);
                    }
                }
                else if (computedAllOfItemsOfData[i].fileName === "DUVAR_TABELA.gpkg" || computedAllOfItemsOfData[i].fileName === "DUVAR_PLAKASI.gpkg") {
                    //console.log("DUVAR_TABELA");
                    //DUVAR_PLAKASI
                    if (computedAllOfItemsOfData[i].data.data.DUVAR) {
                        setAllWallFeatures(computedAllOfItemsOfData[i].data.data.DUVAR.features);
                    }
                    else if (computedAllOfItemsOfData[i].data.data.DUVAR_TABELA) {
                        setAllWallFeatures(computedAllOfItemsOfData[i].data.data.DUVAR_TABELA.features);
                    }
                    else if (computedAllOfItemsOfData[i].data.data.DUVAR_PLAKASI.features) {
                        setAllWallFeatures(computedAllOfItemsOfData[i].data.data.DUVAR_PLAKASI.features);
                    }
                    //console.log("wallFeatures");
                    //console.log(wallFeatures);
                }
                else if (computedAllOfItemsOfData[i].fileName === "DUVAR.gpkg") {
                    //console.log("DUVAR_TABELA");
                    if (computedAllOfItemsOfData[i].data.data.DUVAR) {
                        setAllWallFeatures(computedAllOfItemsOfData[i].data.data.DUVAR.features);
                    }
                    else if (computedAllOfItemsOfData[i].data.data.DUVAR_TABELA) {
                        setAllWallFeatures(computedAllOfItemsOfData[i].data.data.DUVAR_TABELA.features);
                    }
                    //console.log("wallFeatures");
                    //console.log(wallFeatures);
                }
                else if (computedAllOfItemsOfData[i].fileName === "PLAQUES_POTEAU.gpkg") {
                    //console.log("PL_PT");
                    //console.log(computedAllOfItemsOfData[i].data.data.PLAQUES_POTEAU.features);
                    setPlaquesPoteau(computedAllOfItemsOfData[i].data.data.PLAQUES_POTEAU.features);
                }
                else if (computedAllOfItemsOfData[i].fileName === "POTEAU.gpkg") {
                    //console.log("PT");
                    //console.log(computedAllOfItemsOfData[i].data.data.POTEAU.features);
                    setPoteau(computedAllOfItemsOfData[i].data.data.POTEAU.features);
                }
                else if (computedAllOfItemsOfData[i].fileName === "PLAQUES_MURALES.gpkg") {
                    //console.log("PL_MUR");
                    //console.log(computedAllOfItemsOfData[i].data.data.PLAQUES_MURALES.features);
                    setPlaquesMurales(computedAllOfItemsOfData[i].data.data.PLAQUES_MURALES.features);
                    //setPlaquesMurales(ii);
                }

            }

        }
    }, [computedAllOfItemsOfData])


    useEffect(() => {
        //console.log(notFoundItems);
        //buradan devam... 11.11.2024 10:56:XX
        notFoundItems.map(item => {
            let path = `./../projects/${selectedProject}/${item}`;
            axiosPrivateInstance.post('mergintransactions/returnfilecontent', JSON.stringify({
                path: path
            })).then(res => {
                //                console.log("path = ", path);
                //                console.log(res.data);
                setAllOfItemsOfData([...allOfItemsOfData, {
                    fileName: item,
                    data: res.data
                }])
            }).catch(err => {
                console.error(err);
            });
        })
    }, [notFoundItems])


    useEffect(() => {
        //setEditedDoors(allDoorFeatures.filter(item => item.properties.MONTAJDURUM === '4'));
        setEditedDoors(allDoorFeatures.filter(item => {
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '4' || mountageState === 'DÜZENLENDİ' || mountageState === 'DUZENLENDI';
        }));
        //setNotMountedDoors(allDoorFeatures.filter(item => item.properties.MONTAJDURUM === '3'));
        setNotMountedDoors(allDoorFeatures.filter(item => {
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '3'|| mountageState === 'TAKILMADI' || mountageState === 'TAKILAMADI';
        }));
        //setMountedDoors(allDoorFeatures.filter(item => item.properties.MONTAJDURUM === '2'));
        //        setMountedDoors(allDoorFeatures.filter(item => item.properties.MONTAJDURU === '2'));
        setMountedDoors(
            allDoorFeatures.filter(item => {
                const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
                return mountageState === '2'|| mountageState === 'TAKILDI';
            })
        );

        /*
        setMountedDoors(
            allDoorFeatures.filter(item => 
            (item.properties.hasOwnProperty('MONTAJDURU') || item.properties.hasOwnProperty('MONTAJDURUM')) && 
            (item.properties.MONTAJDURUM === '2' || item.properties.MONTAJDURU === '2')
        )
        );
        */
        //        setWillBeMountedDoors(allDoorFeatures.filter(item => item.properties.MONTAJDURUM === '1'));
        setWillBeMountedDoors(allDoorFeatures.filter(item => {

            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '1' || mountageState === 'TAKILACAK' || mountageState == null;
        }));
        let allDoorProperties = [];
        for (let i = 0; i < allDoorFeatures.length; i++) {
            allDoorProperties.push(allDoorFeatures[i].properties);
        }
        //        setGrouppedDoorMountageWrtDate(Object.groupBy(allDoorProperties, (item) => `${item.MONTAJTARIH}-${item.MONTAJDURUM}`));
        setGrouppedDoorMountageWrtDate(
            Object.groupBy(allDoorProperties, (item) => {
                const montajTarih = item.MONTAJTARIH ?? item.MONTAJTARI ?? item.MONTAJTAR_;
                const montajDurum = item.MONTAJDURUM ?? item.MONTAJDURU;
                return `${montajTarih}-${montajDurum}`;
            })
        );
    }, [allDoorFeatures]);


    useEffect(() => {
        setEditedPoles(allPoleFeatures.filter(item => {
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '4';
        }));
        setNotMountedPoles(allPoleFeatures.filter(item => {
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '3';
        }));
        setMountedPoles(allPoleFeatures.filter(item => {
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '2';
        }));
        setWillBeMountedPoles(allPoleFeatures.filter(item => {
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '1' || mountageState == null;
        }));
        let allPoleProperties = [];
        for (let i = 0; i < allPoleFeatures.length; i++) {
            allPoleProperties.push(allPoleFeatures[i].properties);
        }
        setGrouppedPoleMountageWrtDate(Object.groupBy(allPoleProperties, (item) => {
            const montajTarih = item.MONTAJTARIH ?? item.MONTAJTARI ?? item.MONTAJTAR_;
            const montajDurum = item.MONTAJDURUM ?? item.MONTAJDURU;
            return `${montajTarih}-${montajDurum}`;
        }));
    }, [allPoleFeatures]);


    useEffect(() => {
        //    console.log("ALLWALLFEATURES");
        //    console.log(allWallFeatures);
        setEditedWalls(allWallFeatures.filter(item => {
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '4';
        }));
        setNotMountedWalls(allWallFeatures.filter(item => {
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '3';
        }));
        setMountedWalls(allWallFeatures.filter(item => {            
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '2';
        }));
        setWillBeMountedWalls(allWallFeatures.filter(item => {
            const mountageState = item.properties.MONTAJDURU ?? item.properties.MONTAJDURUM;
            return mountageState === '1' || mountageState == null || mountageState == "6";
        }));
        let allWallProperties = [];
        for (let i = 0; i < allWallFeatures.length; i++) {
            allWallProperties.push(allWallFeatures[i].properties);
        }
        setGrouppedWallMountageWrtDate(Object.groupBy(allWallProperties, (item) => {
            const montajTarih = item.MONTAJTARIH ?? item.MONTAJTARI ?? item.MONTAJTAR_;
            const montajDurum = item.MONTAJDURUM ?? item.MONTAJDURU;
            return `${montajTarih}-${montajDurum}`;
        }));
    }, [allWallFeatures])





    useEffect(() => {
        setEditedPlaquesMurales(plaquesMurales.filter(item => item.properties.ÉTAT == 'Réglé' || item.properties.ÉTAT === '4'));
        setNotMountedPlaquesMurales(plaquesMurales.filter(item => item.properties.ÉTAT === 'Non installé' || item.properties.ÉTAT === '3'));
        setMountedPlaquesMurales(plaquesMurales.filter(item => item.properties.ÉTAT === 'Installé' || item.properties.ÉTAT === '2'));
        setWillBeMountedPlaquesMurales(plaquesMurales.filter(item => item.properties.ÉTAT === 'À installer' || item.properties.ÉTAT === '1'));
        let allPlaquesMurales = [];
        for (let i = 0; i < plaquesMurales.length; i++) {
            allPlaquesMurales.push(plaquesMurales[i].properties);
        }
        setGrouppedPlaquesMurales(Object.groupBy(allPlaquesMurales, (item) => `${item.HISTOIRE}-${item.ÉTAT}`));
    }, [plaquesMurales]);



    useEffect(() => {

        setEditedPlaquesPoteau(plaquesPoteau.filter(item => item.properties.ÉTAT === 'Réglé' || item.properties.ÉTAT === '4'));
        setNotMountedPlaquesPoteau(plaquesPoteau.filter(item => item.properties.ÉTAT === 'Non installé' || item.properties.ÉTAT === '3'));
        setMountedPlaquesPoteau(plaquesPoteau.filter(item => item.properties.ÉTAT === 'Installé' || item.properties.ÉTAT === '2'));
        setWillBeMountedPlaquesPoteau(plaquesPoteau.filter(item => item.properties.ÉTAT === 'À installer' || item.properties.ÉTAT === '1'));
        let allPlaquesPoteau = [];
        for (let i = 0; i < plaquesPoteau.length; i++) {
            allPlaquesPoteau.push(plaquesPoteau[i].properties);
        }
        setGrouppedPlaquesPoteau(Object.groupBy(allPlaquesPoteau, (item) => `${item.HISTOIRE}-${item.ÉTAT}`));

    }, [plaquesPoteau]);





    useEffect(() => {
        //        console.log("poteau");
        //        console.log(poteau);
        setEditedPoteau(poteau.filter(item => item.properties.ÉTAT === 'Réglé' || item.properties.ÉTAT === '4'));
        setNotMountedPoteau(poteau.filter(item => item.properties.ÉTAT === 'Non installé' || item.properties.ÉTAT === '3'));
        setMountedPoteau(poteau.filter(item => item.properties.ÉTAT === 'Installé' || item.properties.ÉTAT === '2'));
        setWillBeMountedPoteau(poteau.filter(item => item.properties.ÉTAT === 'À installer' || item.properties.ÉTAT === '1'));
        let allPoteau = [];
        if (poteau.length && poteau.length > 0) {
            for (let i = 0; i < poteau.length; i++) {
                if (poteau[i] && poteau[i].properties) {
                    allPoteau.push(poteau[i].properties);
                }
                else {
                    allPoteau.push("");
                }
            }
        }
        setGrouppedPoteau(Object.groupBy(allPoteau, (item) => `${item.HISTOIRE}-${item.ÉTAT}`));
    }, [poteau]);



    const [isMapOrGraphSelectionAttempted, setIsMapOrGraphSelectionAttempted] = useState(false);
    const [mapOrGraph, setMapOrGraph] = useState("");
    const [isGraphTypeSelected, setIsGraphTypeSelected] = useState(false);
    const [graphType, setGraphType] = useState("-1");

    const handleGraphOrMapSelection = (e) => {
        setIsMapOrGraphSelectionAttempted(true);
        setMapOrGraph(e.target.value);
        setMapType("-1");
        setShowCanvas(false);
        setMapDataForSelectedRecords("");
        setConditions({});
    }

    const handleGraphSketch = (e) => {
        setIsGraphTypeSelected(true);
        setGraphType(e.target.value);
        if (e.target.value !== "-1") {
            setMapType("-1");
            setShowCanvas(true);
        }
    }


    useEffect(() => {
        setGraphData([]);
        setGraphForm("");
        setGraphCaption("");
        if (graphType === "overalldoor") {
            setGraphForm("barchart");
            setGraphCaption(t('enhancedSubDashboardOverAllDoor'));
            let dataOverall = [];
            dataOverall.push({ name: t('willBeMounted'), value: willBeMountedDoors.length });
            dataOverall.push({ name: t('mounted'), value: mountedDoors.length });
            dataOverall.push({ name: t('notMounted'), value: notMountedDoors.length });
            dataOverall.push({ name: t('edited'), value: editedDoors.length });
            setGraphData(dataOverall);
        }
        else if (graphType === "overallwall") {
            setGraphForm("barchart");
            setGraphCaption(t('enhancedSubDashboardOverAllWall'))
            let dataOverall = [];
            dataOverall.push({ name: t('willBeMounted'), value: willBeMountedWalls.length });
            dataOverall.push({ name: t('mounted'), value: mountedWalls.length });
            dataOverall.push({ name: t('notMounted'), value: notMountedWalls.length });
            dataOverall.push({ name: t('edited'), value: editedWalls.length });
            setGraphData(dataOverall);
        }
        else if (graphType === "overallpole") {
            setGraphForm("barchart");
            setGraphCaption(t('enhancedSubDashboardOverAllPole'))
            let dataOverall = [];
            dataOverall.push({ name: t('willBeMounted'), value: willBeMountedPoles.length });
            dataOverall.push({ name: t('mounted'), value: mountedPoles.length });
            dataOverall.push({ name: t('notMounted'), value: notMountedPoles.length });
            dataOverall.push({ name: t('edited'), value: editedPoles.length });
            setGraphData(dataOverall);
        }
        else if (graphType === "poveralldoor") {
            setGraphForm("piechart");
            setGraphCaption(t('enhancedSubDashboardPoverAllDoor'));
            let dataOverall = [];
            dataOverall.push({ name: t('willBeMounted'), value: willBeMountedDoors.length });
            dataOverall.push({ name: t('mounted'), value: mountedDoors.length });
            dataOverall.push({ name: t('notMounted'), value: notMountedDoors.length });
            dataOverall.push({ name: t('edited'), value: editedDoors.length });
            setGraphData(dataOverall);
        }
        else if (graphType === "poverallwall") {
            setGraphForm("piechart");
            setGraphCaption(t('enhancedSubDashboardPoverAllWall'))
            let dataOverall = [];
            dataOverall.push({ name: t('willBeMounted'), value: willBeMountedWalls.length });
            dataOverall.push({ name: t('mounted'), value: mountedWalls.length });
            dataOverall.push({ name: t('notMounted'), value: notMountedWalls.length });
            dataOverall.push({ name: t('edited'), value: editedWalls.length });
            setGraphData(dataOverall);
        }
        else if (graphType === "poverallpole") {
            setGraphForm("piechart");
            setGraphCaption(t('enhancedSubDashboardPoverAllPole'))
            let dataOverall = [];
            dataOverall.push({ name: t('willBeMounted'), value: willBeMountedPoles.length });
            dataOverall.push({ name: t('mounted'), value: mountedPoles.length });
            dataOverall.push({ name: t('notMounted'), value: notMountedPoles.length });
            dataOverall.push({ name: t('edited'), value: editedPoles.length });
            setGraphData(dataOverall);
        }

        else if (graphType === "overallplqpot") {
            setGraphForm("barchart");
            setGraphCaption('Tableau des plaques postales (graphique à barres)')
            let dataOverall = [];
            dataOverall.push({ name: 'Sera Porté', value: willBeMountedPlaquesPoteau.length });
            dataOverall.push({ name: 'Monte', value: mountedPlaquesPoteau.length });
            dataOverall.push({ name: 'Non assemblé', value: notMountedPlaquesPoteau.length });
            dataOverall.push({ name: 'Édité', value: editedPlaquesPoteau.length });
            setGraphData(dataOverall);
        }

        else if (graphType === "overallplqmur") {
            setGraphForm("barchart");
            setGraphCaption('Tableau des plaques murales (graphique à barres)')
            let dataOverall = [];
            dataOverall.push({ name: 'Sera Porté', value: willBeMountedPlaquesMurales.length });
            dataOverall.push({ name: 'Monte', value: mountedPlaquesMurales.length });
            dataOverall.push({ name: 'Non assemblé', value: notMountedPlaquesMurales.length });
            dataOverall.push({ name: 'Édité', value: editedPlaquesMurales.length });
            setGraphData(dataOverall);
        }

        else if (graphType === "overallpoteau") {
            setGraphForm("barchart");
            setGraphCaption('Tableau des poteau (graphique à barres)')
            let dataOverall = [];
            dataOverall.push({ name: 'Sera Porté', value: willBeMountedPoteau.length });
            dataOverall.push({ name: 'Monte', value: mountedPoteau.length });
            dataOverall.push({ name: 'Non assemblé', value: notMountedPoteau.length });
            dataOverall.push({ name: 'Édité', value: editedPoteau.length });
            setGraphData(dataOverall);
        }

        else if (graphType === "poverallplqpot") {
            setGraphForm("piechart");
            setGraphCaption('Tableau des plaques postales (tableau circulaire)')
            let dataOverall = [];
            dataOverall.push({ name: 'Sera Porté', value: willBeMountedPlaquesPoteau.length });
            dataOverall.push({ name: 'Monte', value: mountedPlaquesPoteau.length });
            dataOverall.push({ name: 'Non assemblé', value: notMountedPlaquesPoteau.length });
            dataOverall.push({ name: 'Édité', value: editedPlaquesPoteau.length });
            setGraphData(dataOverall);
        }

        else if (graphType === "poverallplqmur") {
            setGraphForm("piechart");
            setGraphCaption('Tableau des plaques murales (tableau circulaire)')
            let dataOverall = [];
            dataOverall.push({ name: 'Sera Porté', value: willBeMountedPlaquesMurales.length });
            dataOverall.push({ name: 'Monte', value: mountedPlaquesMurales.length });
            dataOverall.push({ name: 'Non assemblé', value: notMountedPlaquesMurales.length });
            dataOverall.push({ name: 'Édité', value: editedPlaquesMurales.length });
            setGraphData(dataOverall);
        }

        else if (graphType === "poverallpoteau") {
            setGraphForm("piechart");
            setGraphCaption('Tableau des poteau (tableau circulaire)')
            let dataOverall = [];
            dataOverall.push({ name: 'Sera Porté', value: willBeMountedPoteau.length });
            dataOverall.push({ name: 'Monte', value: mountedPoteau.length });
            dataOverall.push({ name: 'Non assemblé', value: notMountedPoteau.length });
            dataOverall.push({ name: 'Édité', value: editedPoteau.length });
            setGraphData(dataOverall);
        }



        //, , , poverallplqpot, poverallplqmur, poverallpoteau
    }, [graphType]);




    useEffect(() => {
        if (grouppedDoorMountagesWrtDate && Object.keys(grouppedDoorMountagesWrtDate).length > 0) {
            let mountedDoorYest = 0;
            let mountedDoorTod = 0;
            //obtain date and mountage state seperately, if contains "-" or obtain array whose key is in 'XXXX-XX-XX-2' format, detect 2 after dash and ????
            let mountedDoorsYest = [];
            for (let i = 0; i < Object.keys(grouppedDoorMountagesWrtDate).length; i++) {
                if (Object.keys(grouppedDoorMountagesWrtDate)[i].includes("-")) {
                    let dateString = Object.keys(grouppedDoorMountagesWrtDate)[i].split("-")[0];
                    let date = moment(dateString, "DD.MM.YYYY"); // Specify the format
                    let now = moment();
                    let mountageState = Object.keys(grouppedDoorMountagesWrtDate)[i].split("-")[1];
                    let yesterday = moment().subtract(1, 'days');
                    let today = moment().format("DD.MM.YYYY");
                    let formattedDate = date.format("DD.MM.YYYY");
                    let formattedYesterday = yesterday.format("DD.MM.YYYY");
                    //		    console.log("TODAY => "+ today);	
                    if (formattedDate === formattedYesterday && (mountageState == 2 || mountageState == 4 || mountageState == "TAKILDI" || mountageState == "DÜZENLENDİ" || mountageState == "DUZENLENDI")) {
                        mountedDoorYest += grouppedDoorMountagesWrtDate[Object.keys(grouppedDoorMountagesWrtDate)[i]].length;
                    }

                    if (formattedDate === today && (mountageState == 2 || mountageState == 4 || mountageState == "TAKILDI" || mountageState == "DÜZENLENDİ" || mountageState == "DUZENLENDI")) {
                        mountedDoorTod += grouppedDoorMountagesWrtDate[Object.keys(grouppedDoorMountagesWrtDate)[i]].length;
                    }



                    // Check if the date and yesterday are the same
                    /*
                    if (date.isSame(yesterday, 'day') && (mountageState === '2' || mountageState === '4')) {
                        mountedDoorYest++;
                    } else if (date.isSame(now, "day") && (mountageState === '2' || mountageState === '4')) {
                        mountedDoorTod++;
                    }*/
                }
            }

            if (mountedDoorYest > 0) {
                setNumberOfMountedDoorYest(mountedDoorYest);
            }

            if (mountedDoorTod > 0) {
                setNumberOfMountedDoorTod(mountedDoorTod);
            }
            /*
                        if (grouppedDoorMountagesWrtDate[moment().format('DD-MM-YYYY')] !== undefined) {
            //                setNumberOfMountedDoorTod(grouppedDoorMountagesWrtDate[moment().format('DD-MM-YYYY')].filter(item => item.MONTAJDURUM == '2').concat(grouppedDoorMountagesWrtDate[moment().format('DD-MM-YYYY')].filter(item => item.MONTAJDURUM == '4')).length);
            setNumberOfMountedDoorTod(grouppedDoorMountagesWrtDate[moment().format('DD-MM-YYYY')].filter(item => {
                let mountageState = item.MONTAJDURUM ?? item.MONTAJDURU
                return mountageState == 2 || mountageState == 4
            }).concat(grouppedDoorMountagesWrtDate[moment().format('DD-MM-YYYY')].filter(item => {
                let mountageState = item.MONTAJDURUM ?? item.MONTAJDURU
                return mountageState ==2 || mountageState == 4
            })).length);
              
              
                        }
                        if (grouppedDoorMountagesWrtDate[moment().subtract(1, "day").format('DD-MM-YYYY')] !== undefined) {
                            setNumberOfMountedDoorYest(grouppedDoorMountagesWrtDate[moment().subtract(1, "day").format('DD-MM-YYYY')].length);
                        }
            */
        }


        if (grouppedWallMountagesWrtDate && Object.keys(grouppedWallMountagesWrtDate).length > 0) {
            let mountedWallYest = 0;
            let mountedWallTod = 0;
            //obtain date and mountage state seperately, if contains "-" or obtain array whose key is in 'XXXX-XX-XX-2' format, detect 2 after dash and ????
            for (let i = 0; i < Object.keys(grouppedWallMountagesWrtDate).length; i++) {
                if (Object.keys(grouppedWallMountagesWrtDate)[i].includes("-")) {
                    let dateString = Object.keys(grouppedWallMountagesWrtDate)[i].split("-")[0];
                    let date = moment(dateString, "DD.MM.YYYY"); // Specify the format
                    let yesterday = moment().subtract(1, 'days');
                    let today = moment().format("DD.MM.YYYY");
                    let formattedDate = date.format("DD.MM.YYYY");
                    let formattedYesterday = yesterday.format("DD.MM.YYYY");
                    let now = moment();
                    let mountageState = Object.keys(grouppedWallMountagesWrtDate)[i].split("-")[1];


                    /*
                                        // Check if the date and yesterday are the same
                                        if (date.isSame(yesterday, 'day') && (mountageState === '2' || mountageState === '4')) {
                                            mountedWallYest++;
                                        } else if (date.isSame(now, "day") && (mountageState === '2' || mountageState === '4')) {
                                            mountedWallTod++;
                                        }
                    */
                    if (formattedDate === formattedYesterday && (mountageState == 2 || mountageState == 4)) {
                        mountedWallYest += grouppedWallMountagesWrtDate[Object.keys(grouppedWallMountagesWrtDate)[i]].length;
                    }

                    if (formattedDate === today && (mountageState == 2 || mountageState == 4)) {
                        mountedWallTod += grouppedWallMountagesWrtDate[Object.keys(grouppedWallMountagesWrtDate)[i]].length;
                    }
                }
            }

            if (mountedWallYest > 0) {
                setNumberOfMountedWallYest(mountedWallYest);
            }

            if (mountedWallTod > 0) {
                setNumberOfMountedWallTod(mountedWallTod);
            }

            /*
            
                        if (grouppedWallMountagesWrtDate[moment().format('DD-MM-YYYY')] !== undefined) {
                            setNumberOfMountedWallTod(grouppedWallMountagesWrtDate[moment().format('DD-MM-YYYY')].length);
                        }
                        if (grouppedWallMountagesWrtDate[moment().subtract(1, "day").format('DD-MM-YYYY')] !== undefined) {
                            setNumberOfMountedWallYest(grouppedWallMountagesWrtDate[moment().subtract(1, "day").format('DD-MM-YYYY')].filter(item => item.MONTAJDURUM == '2').concat(grouppedDoorMountagesWrtDate[moment().format('DD-MM-YYYY')].filter(item => item.MONTAJDURUM == '4')).length);
                        }
            */
        }


        if (grouppedPoleMountagesWrtDate && Object.keys(grouppedPoleMountagesWrtDate).length > 0) {

            /*
            if (grouppedPoleMountagesWrtDate[moment().format('DD-MM-YYYY')] !== undefined) {
                setNumberOfMountedPoleTod(grouppedPoleMountagesWrtDate[moment().format('DD-MM-YYYY')].length);
            }
            if (grouppedPoleMountagesWrtDate[moment().subtract(1, "day").format('DD-MM-YYYY')] !== undefined) {
                setNumberOfMountedPoleYest(grouppedPoleMountagesWrtDate[moment().subtract(1, "day").format('DD-MM-YYYY')].filter(item => item.MONTAJDURUM == '2').concat(grouppedDoorMountagesWrtDate[moment().format('DD-MM-YYYY')].filter(item => item.MONTAJDURUM == '4')).length);
            }
    */
            let mountedPoleYest = 0;
            let mountedPoleTod = 0;
            //obtain date and mountage state seperately, if contains "-" or obtain array whose key is in 'XXXX-XX-XX-2' format, detect 2 after dash and ????
            for (let i = 0; i < Object.keys(grouppedPoleMountagesWrtDate).length; i++) {
                if (Object.keys(grouppedPoleMountagesWrtDate)[i].includes("-")) {
                    let dateString = Object.keys(grouppedPoleMountagesWrtDate)[i].split("-")[0];
                    let date = moment(dateString, "DD.MM.YYYY"); // Specify the format
                    let yesterday = moment().subtract(1, 'days');
                    let today = moment().format("DD.MM.YYYY");
                    let formattedDate = date.format("DD.MM.YYYY");
                    let formattedYesterday = yesterday.format("DD.MM.YYYY");

                    let mountageState = Object.keys(grouppedPoleMountagesWrtDate)[i].split("-")[1];



                    // Check if the date and yesterday are the same
                    /*
                    if (date.isSame(yesterday, 'day') && (mountageState === '2' || mountageState === '4')) {
                        mountedPoleYest++;
                    } else if (date.isSame(now, "day") && (mountageState === '2' || mountageState === '4')) {
                        mountedPoleTod++;
                    }
                    */
                    if (formattedDate === formattedYesterday && (mountageState == 2 || mountageState == 4)) {
                        mountedPoleYest += grouppedPoleMountagesWrtDate[Object.keys(grouppedPoleMountagesWrtDate)[i]].length;
                    }

                    if (formattedDate === today && (mountageState == 2 || mountageState == 4)) {
                        mountedPoleTod += grouppedPoleMountagesWrtDate[Object.keys(grouppedPoleMountagesWrtDate)[i]].length;
                    }

                }
            }

            if (mountedPoleYest > 0) {
                setNumberOfMountedPoleYest(mountedPoleYest);
            }

            if (mountedPoleTod > 0) {
                setNumberOfMountedPoleTod(mountedPoleTod);
            }
        }
    }, [grouppedDoorMountagesWrtDate, grouppedPoleMountagesWrtDate, grouppedWallMountagesWrtDate]);


    useEffect(() => {
        if (grouppedPlaquesMurales && Object.keys(grouppedPlaquesMurales).length > 0) {

            let mountedPlaquesMuralesYest = 0;
            let mountedPlaquesMuralesTod = 0;

            for (let i = 0; i < Object.keys(grouppedPlaquesMurales).length; i++) {


                if (Object.keys(grouppedPlaquesMurales)[i].includes("-")) {
                    let dateString = Object.keys(grouppedPlaquesMurales)[i].split("-")[0];
                    let date = moment(dateString, "DD.MM.YYYY"); // Specify the format
                    let yesterday = moment().subtract(1, 'days');
                    let today = moment().format("DD.MM.YYYY");
                    let formattedDate = date.format("DD.MM.YYYY");
                    let formattedYesterday = yesterday.format("DD.MM.YYYY");

                    let mountageState = Object.keys(grouppedPlaquesMurales)[i].split("-")[1];
                    if (formattedDate == formattedYesterday && (mountageState == "Installé" || mountageState == "Réglé")) {
                        mountedPlaquesMuralesYest += grouppedPlaquesMurales[Object.keys(grouppedPlaquesMurales)[i]].length;
                    }

                    if (formattedDate == today && (mountageState == "Installé" || mountageState == "Réglé")) {
                        mountedPlaquesMuralesTod += grouppedPlaquesMurales[Object.keys(grouppedPlaquesMurales)[i]].length;
                    }

                }

            }



            if (mountedPlaquesMuralesYest > 0) {
                setPlaquesMuralesYest(mountedPlaquesMuralesYest);
            }

            if (mountedPlaquesMuralesTod > 0) {
                setPlaquesMuralesTod(mountedPlaquesMuralesTod);
            }

        }



        if (grouppedPlaquesPoteau && Object.keys(grouppedPlaquesPoteau).length > 0) {

            let mountedPlaquesPoteauYest = 0;
            let mountedPlaquesPoteauTod = 0;
            //obtain date and mountage state seperately, if contains "-" or obtain array whose key is in 'XXXX-XX-XX-2' format, detect 2 after dash and ????
            for (let i = 0; i < Object.keys(grouppedPlaquesPoteau).length; i++) {
                if (Object.keys(grouppedPlaquesPoteau)[i].includes("-")) {

                    let dateString = Object.keys(grouppedPlaquesPoteau)[i].split("-")[0];
                    let date = moment(dateString, "DD.MM.YYYY"); // Specify the format
                    let yesterday = moment().subtract(1, 'days');
                    let today = moment().format("DD.MM.YYYY");
                    let formattedDate = date.format("DD.MM.YYYY");
                    let formattedYesterday = yesterday.format("DD.MM.YYYY");

                    let mountageState = Object.keys(grouppedPlaquesPoteau)[i].split("-")[1];

                    if (formattedDate == formattedYesterday && (mountageState == "Installé" || mountageState == "Réglé")) {
                        mountedPlaquesPoteauYest += grouppedPlaquesPoteau[Object.keys(grouppedPlaquesPoteau)[i]].length;
                    }

                    if (formattedDate == today && (mountageState == "Installé" || mountageState == "Réglé")) {
                        mountedPlaquesPoteauTod += grouppedPlaquesPoteau[Object.keys(grouppedPlaquesPoteau)[i]].length;
                    }

                    // Check if the date and yesterday are the same
                    /*
                    if (date.isSame(yesterday, 'day') && (mountageState === '2' || mountageState === '4')) {
                        mountedPlaquesPoteauYest++;
                    } else if (date.isSame(now, "day") && (mountageState === '2' || mountageState === '4')) {
                        mountedPlaquesPoteauTod++;
                    }*/
                }
            }

            if (mountedPlaquesPoteauYest > 0) {
                setPlaquesPoteauYest(mountedPlaquesPoteauYest);
            }

            if (mountedPlaquesPoteauTod > 0) {
                setPlaquesPoteauTod(mountedPlaquesPoteauTod);
            }

        }


        if (grouppedPoteau && Object.keys(grouppedPoteau).length > 0) {

            let mountedPoteauYest = 0;
            let mountedPoteauTod = 0;
            //obtain date and mountage state seperately, if contains "-" or obtain array whose key is in 'XXXX-XX-XX-2' format, detect 2 after dash and ????
            for (let i = 0; i < Object.keys(grouppedPoteau).length; i++) {
                if (Object.keys(grouppedPoteau)[i].includes("-")) {
                    let dateString = Object.keys(grouppedPoteau)[i].split("-")[0];
                    let date = moment(dateString, "DD.MM.YYYY"); // Specify the format
                    let yesterday = moment().subtract(1, 'days');
                    let today = moment().format("DD.MM.YYYY");
                    let formattedDate = date.format("DD.MM.YYYY");
                    let formattedYesterday = yesterday.format("DD.MM.YYYY");

                    let mountageState = Object.keys(grouppedPoteau)[i].split("-")[1];

                    if (formattedDate == formattedYesterday && (mountageState == "Installé" || mountageState == "Réglé")) {
                        mountedPoteauYest += grouppedPoteau[Object.keys(grouppedPoteau)[i]].length;
                    }

                    if (formattedDate == today && (mountageState == "Installé" || mountageState == "Réglé")) {
                        mountedPoteauTod += grouppedPoteau[Object.keys(grouppedPoteau)[i]].length;
                    }

                    /*
                    if (date.isSame(yesterday, 'day') && (mountageState === '2' || mountageState === '4')) {
                        mountedPoteauYest++;
                    } else if (date.isSame(now, "day") && (mountageState === '2' || mountageState === '4')) {
                        mountedPoteauTod++;
                    }
                    */
                }
            }

            if (mountedPoteauYest > 0) {
                setPoteauYest(mountedPoteauYest);
            }

            if (mountedPoteauTod > 0) {
                setPoteauTod(mountedPoteauTod);
            }

        }
    }, [grouppedPlaquesMurales, grouppedPlaquesPoteau, grouppedPoteau])








    const handleTypeSelection = (e) => {
        setDocType(e.target.value);
        setIsDocTypeSelected(true);
        setisFilteredByMountageState(false);
        setFilterWrtMountageState("-1");
        setFilterWrtStaff("-1");
        setIsFilteredByStaff(false);
        setFilterValue("-1");
        setIsFilteredByArea(false);
        setIsFilteredByDate(false);
        setFilterValueForStaff("-1");
        setAreaValue("-1");
        //setIsFilteredByDate(false);
        setFirstDate("");
        setSecondDate("");
        setFilteredDateRecords([]);
        setNewMountageState(-1);
        //console.log(filteredRecords.length)
        //setNewStaffValue, setNewAreaValue, setNewFirstDate, setNewSecondDate
        setNewStaffValue(-1);
        setNewAreaValue(-1);
        setNewFirstDate("");
        setNewSecondDate("");


        //       if(!isFilteredByArea && !isFilteredByMountageState && !isFilteredByStaff){

    }

    useEffect(() => {
        ////console.log(data);
        ////console.log(docType.concat(".gpkg"))
        data.map(item => {
            /*
            if(Object.keys(item.data.data)[0] === docType) {
                
                setSelectedRecords(item.data.data[docType].features);
                ////console.log(item.data.data[docType].features);
            }
                //check for filename, not keys
            */
            if (item.fileName === docType.concat('.gpkg') && item.data.data) {
                setSelectedRecords(item.data.data[Object.keys(item.data.data)[0]].features);

            }

        })
    }, [docType]);

    useEffect(() => {

        //group wrt staff in there, don't forget to push all properties from selectedRecords...
        let propertiesOfSelectedRecordsTemp = [];
        for (let i = 0; i < selectedRecords.length; i++) {
            propertiesOfSelectedRecordsTemp.push(selectedRecords[i].properties);
        }
        //setPropertiesOfSelectedRecords(propertiesOfSelectedRecordsTemp);
        setPropertiesOfSelectedRecords(propertiesOfSelectedRecordsTemp);
    }, [selectedRecords])

    useEffect(() => {
        setStuffForSelectedRecords(
            Object.keys(
                Object.groupBy(
                    propertiesOfSelectedRecords.filter(record => record.MONTAJYAPA || record.ILKMONTAJ || record.INSTALLATEUR),
                    (record) => record.MONTAJYAPA || record.ILKMONTAJ || record.INSTALLATEUR
                )
            )
        );
        /*
        setStuffForSelectedRecords(Object.keys(Object.groupBy(propertiesOfSelectedRecords, (record) => record.MONTAJYAPA || record.ILKMONTAJ || record.INSTALLATEUR)));
        */
        //setStuffForSelectedRecords
        //        setAreas(Object.keys(Object.groupBy(propertiesOfSelectedRecords, (record) => record.MAHALLE || record.QUARTIERS)));
/*
        setAreas(
            Object.keys(
                Object.groupBy(propertiesOfSelectedRecords, (record) => record.MAHALLE || record.MAHALLE_ || record.QUARTIERS)
            ).sort((a, b) => a.localeCompare(b, 'tr'))
        );
*/
        setAreas(
            Object.keys(
                Object.groupBy(
                    propertiesOfSelectedRecords.filter(record => record.MAHALLE || record.MAHALLE_ || record.MAHALLE_1 || record.QUARTIERS),
                    (record) => record.MAHALLE || record.MAHALLE_ || record.MAHALLE_1 || record.QUARTIERS
                )
            ).sort((a, b) => a.localeCompare(b, 'tr'))
        );
    }, [propertiesOfSelectedRecords])





    const handleSelectedRecordsFiltering = (e) => {
        setFilterValue(e.target.value);
        //        alert(e.target.value);
        setisFilteredByMountageState(true);
        setFilterWrtMountageState(e.target.value);//filterWrtStaff, filterWrtMountageState, isFilteredByArea
    }





    function handleSelectedRecordsFilteringWrtStuff(e) {
        setFilterValueForStaff(e.target.value);
        setIsFilteredByStaff(true);
        setFilterWrtStaff(e.target.value);
    }

    function handleSelectedRecordsFilteringWrtArea(e) {
        setAreaValue(e.target.value);
        setIsFilteredByArea(true);
    }
    /*
        useEffect(() => {
            if(!isFilteredByStaff){
                setFilteredRecords(selectedRecords);
            }
            else{
                //setFilteredRecords(selectedRecords.filter(item => item.properties.MONTAJDURUM === String(filterValue)));
                if(docType === "KAPI")
                {
                    setFilteredRecords(propertiesOfSelectedRecords.filter(item => item.MONTAJYAPAN = filterValueForStaff));
                }
                else{
                    setFilteredRecords(propertiesOfSelectedRecords.filter(item => item.MONTAJYAPA = filterValueForStaff));
                }
            }
            
        }, [filterValueForStaff, isFilteredByStaff, selectedRecords, ]);
    */


    const processDataInChunks = (data, filterValue, setFilteredMountageRecords) => {
        const chunkSize = 1000; // Process 1000 items at a time
        let index = 0;
        let filteredData = [];

        const processChunk = () => {
            const chunk = data.slice(index, index + chunkSize);

            // Filter the chunk
            const filteredChunk = chunk.filter(item =>
                (item.MONTAJDURUM === null || item.ÉTAT === null || item.MONTAJDURU === null) ||
                (item.MONTAJDURUM ? item.MONTAJDURUM === filterValue : item.ÉTAT === filterValue) ||
                (item.MONTAJDURU ? item.MONTAJDURU === filterValue : false)
            );

            // Add the filtered chunk to the result
            filteredData = filteredData.concat(filteredChunk);

            // Update the state with the current filtered data
            setFilteredMountageRecords([...filteredData]);

            // Move to the next chunk
            index += chunkSize;

            // If there are more items to process, schedule the next chunk
            if (index < data.length) {
                setTimeout(processChunk, 0); // Use setTimeout to avoid blocking the main thread
            }
        };

        // Start processing the first chunk
        processChunk();
    };


    useEffect(() => {
        if ((!isFilteredByArea && !isFilteredByMountageState && !isFilteredByStaff && !isFilteredByDate)) {
            setFilteredRecords([]);
            setTemp([]);
            setArrayBox([]);
        }
        //console.log(propertiesOfSelectedRecords.length);
        if (filterValue == -1) {
            setisFilteredByMountageState(false);
        }

        if (filterValueForStaff == -1) {
            setIsFilteredByStaff(false);
        }
        if (areaValue == -1) {
            setIsFilteredByArea(false);
        }
        if ((firstDate && firstDate.length === 0) || (secondDate && secondDate.length === 0)) {
            setIsFilteredByDate(false);
        }
        ////console.log("filterValue"+filterValue+"\nfilterValueForStaff "+filterValueForStaff+"\nareaValue = "+areaValue);
        ////console.log("MONTAJ DURUM => ");
        if (filterValue === "1") {

            /*		    
            console.log("concatted");
            console.log(propertiesOfSelectedRecords.filter(item => 
                (item.MONTAJDURUM === null || item.ÉTAT === null || item.MONTAJDURU === null)
            ).concat(propertiesOfSelectedRecords
                        .filter(item => 
                          (item.MONTAJDURUM ? item.MONTAJDURUM === filterValue : item.ÉTAT === filterValue) ||
                          (item.MONTAJDURU ? item.MONTAJDURU === filterValue : false)
                        )));
                        
            setFilteredMountageRecords(propertiesOfSelectedRecords.filter(item => 
                (item.MONTAJDURUM === null || item.ÉTAT === null || item.MONTAJDURU === null)
            ).concat(propertiesOfSelectedRecords
                        .filter(item => 
                          (item.MONTAJDURUM ? item.MONTAJDURUM === filterValue : item.ÉTAT === filterValue) ||
                          (item.MONTAJDURU ? item.MONTAJDURU === filterValue : false)
                        )));
            */

            //(item.MONTAJDURU && item.MONTAJDURU === null) || (item.MONTAJDURUM && item.MONTAJDURUM === null ) || (item.ÉTAT && item.ÉTAT === null)



            /*
            alert(filterValue+"  "+typeof filterValue);
            setFilteredMountageRecords(propertiesOfSelectedRecords.filter(item => 
                (item.MONTAJDURUM === null || item.ÉTAT === null || item.MONTAJDURU === null || !((item.MONTAJDURU && item.MONTAJDURU === null) || (item.MONTAJDURUM && item.MONTAJDURUM === null ) || (item.ÉTAT && item.ÉTAT === null)))
            ).concat(propertiesOfSelectedRecords
                        .filter(item => 
                          (item.MONTAJDURUM ? item.MONTAJDURUM === filterValue : item.ÉTAT === filterValue) ||
                          (item.MONTAJDURU ? item.MONTAJDURU === filterValue : false)
                        )));
            
            */










            let setToBeMounted = [];
            propertiesOfSelectedRecords.filter(item =>
                (item.MONTAJDURUM === null || item.ÉTAT === null || item.MONTAJDURU === null)
            ).concat(propertiesOfSelectedRecords
                .filter(item =>
                    (item.MONTAJDURUM ? item.MONTAJDURUM === filterValue : item.ÉTAT === filterValue) ||
                    (item.MONTAJDURU ? item.MONTAJDURU === filterValue : false)
                )).map(item => {

                    if ((item.MONTAJDURU && item.MONTAJDURU === null) || (item.MONTAJDURUM && item.MONTAJDURUM === null) || (item.ÉTAT && item.ÉTAT === null)) {
                        console.log("VV");
                    }
                    else {
                        setToBeMounted.push(item);
                    }

                });

            setFilteredMountageRecords(setToBeMounted);



            /*
            setFilteredMountageRecords([{
            "ACIKLAMA": "SARAC",
            "DISKAPINO1":"9A",
            "FOTO1": "FVZ_ÇORUH CD._539555136_1.jpg",
            "FOTO2": "FVZ_ÇORUH CD._539555136_2.jpg",
            "ILCE": "KOCASİNAN",
            "KIMLIKNO": "539555136",
            "MAHALLE": "FEVZİ ÇAKMAK",
            "MAHKOD": "FVZ",
            "MONTAJDURU":"2",
            "MONTAJSAAT": "10.27",
            "MONTAJTARI": "18.02.2025",
            "MONTAJYAPA": "kayserisahamontaj1",
            "OBJECTID": 4,
            "TAKILAMADI": null,
            "YOLADI": "ÇORUH CD."
            }]);
              */
        }



        else if (filterValue === '2') {
            /*
                setFilteredMountageRecords(propertiesOfSelectedRecords.filter(item => item.MONTAJDURUM ? item.MONTAJDURUM === filterValue : item.ÉTAT === filterValue).concat(propertiesOfSelectedRecords.filter(item => item.MONTAJDURUM ? item.MONTAJDURUM === "4" : item.ÉTAT === "4")));
           */
            setFilteredMountageRecords(
                propertiesOfSelectedRecords
                    .filter(item =>
                        (item.MONTAJDURUM ? item.MONTAJDURUM === filterValue : item.ÉTAT === filterValue) ||
                        (item.MONTAJDURU ? item.MONTAJDURU === filterValue : false)
                    )
                    .concat(
                        propertiesOfSelectedRecords.filter(item =>
                            (item.MONTAJDURUM ? item.MONTAJDURUM === "4" : item.ÉTAT === "4") ||
                            (item.MONTAJDURU ? item.MONTAJDURU === "4" : false)
                        )
                    )
            );
        }//if(item.DURUM || item.DURU)
        else {
            setFilteredMountageRecords(propertiesOfSelectedRecords
                .filter(item =>
                    (item.MONTAJDURUM ? item.MONTAJDURUM === filterValue : item.ÉTAT === filterValue) ||
                    (item.MONTAJDURU ? item.MONTAJDURU === filterValue : false)
                ));
        }

        setFilteredStaffRecords(propertiesOfSelectedRecords.filter(item => {
            if(item.MONTAJYAPA) return item.MONTAJYAPA == filterValueForStaff;
            if(item.INSTALLATEUR) return item.INSTALLATEUR == filterValueForStaff;
            if(item.ILKMONTAJ) return item.ILKMONTAJ == filterValueForStaff;
            //return false;
        }));

        ////console.log("MAHALLE");
        /*
        setFilteredAreaRecords(propertiesOfSelectedRecords.filter(item => {
        item.MAHALLE ? item.MAHALLE == areaValue : item.QUARTIERS == areaValue
        }));
        */
        
        setFilteredAreaRecords(
          propertiesOfSelectedRecords.filter(item => {
            if (item.MAHALLE) return item.MAHALLE == areaValue;
            if (item.QUARTIERS) return item.QUARTIERS == areaValue;
            if (item.MAHALLE_) return item.MAHALLE_ == areaValue;
            if (item.MAHALLE_1) return item.MAHALLE_1 == areaValue;
          })
        );

        //filteredDateRecords u burada set et!
        if (isFilteredByDate) {
            let dates = [];
            let arr = [];

            for (let i = 0; i < moment(secondDate).diff(firstDate, "days"); i++) {
            /*
                arr.push(propertiesOfSelectedRecords.filter(item =>
                    item.MONTAJTARIH ? item.MONTAJTARIH == moment(firstDate).add(i, "days").format('DD.MM.YYYY').toString() :
                    item.HISTOIRE ? item.HISTOIRE == moment(firstDate).add(i, "days").format('DD.MM.YYYY').toString() || item.HISTOIRE == moment(firstDate).add(i, "days").format('DD.MM.YY').toString() : 
                    item.MONTAJTARI == moment(firstDate).add(i, "days").format('DD.MM.YYYY').toString()).map(item => item)
                );
            */
arr.push(propertiesOfSelectedRecords.filter(item =>
    item.MONTAJTARIH ? item.MONTAJTARIH == moment(firstDate).add(i, "days").format('DD.MM.YYYY').toString() :
    item.HISTOIRE ? item.HISTOIRE == moment(firstDate).add(i, "days").format('DD.MM.YYYY').toString() || item.HISTOIRE == moment(firstDate).add(i, "days").format('DD.MM.YY').toString() :
    item.MONTAJTARI ? item.MONTAJTARI == moment(firstDate).add(i, "days").format('DD.MM.YYYY').toString() :
    item.MONTAJTAR_ ? item.MONTAJTAR_ == moment(firstDate).add(i, "days").format('DD.MM.YYYY').toString() :
    false
).map(item => item)
);
            }
            setFilteredDateRecords(arr.flat());
            setIsFilteredByDate(true);
        }

        ////console.log(filteredDateRecords);
    }, [filterValue, isFilteredByMountageState, isFilteredByStaff, filterValueForStaff, filterWrtMountageState, filterWrtStaff, areaValue, firstDate, secondDate, propertiesOfSelectedRecords]);





    useEffect(() => {

        /*
        let arrayBoxPre = []; 
        arrayBoxPre.push(filteredMountageRecords);
        arrayBoxPre.push(filteredStaffRecords);
        arrayBoxPre.push(filteredAreaRecords);
        if(isFilteredByDate)
            arrayBoxPre.push(filteredDateRecords);
        
        if(arrayBoxPre.filter(item => item.length > 0).length > 1)
            {
                setFilteredRecords(arrayBoxPre.filter(item => item.length > 0).reduce((acc, array) => {
                    return acc.filter(element => array.includes(element));
                }
                ));
                //console.log(arrayBoxPre);
            }
            else if(arrayBoxPre.filter(item => item.length > 0).length == 1){
                for(let i=0; i<arrayBoxPre.length; i++)
                {
                    if(arrayBoxPre[i].length > 0)
                    {
                        setFilteredRecords(arrayBoxPre[i]);
                    }
                }
                
            }
            else{
                setFilteredRecords([]);
            }

         //console.log("isFilteredByArea => ", isFilteredByArea);
         //console.log("isFilteredByDate => ", isFilteredByDate);
         //console.log("isFilteredByMountageState => ", isFilteredByMountageState);
         //console.log("isFilteredByStaff => ", isFilteredByStaff);  
         //console.log("firstDate => ", firstDate.length);
         //console.log("secondDate => ", secondDate.length);


          */
        setShowFilteredRecordsOnMapCheck(true);
        let arrayBoxPre = [];
        if (isFilteredByMountageState)
            arrayBoxPre.push(filteredMountageRecords);
        if (isFilteredByStaff)
            arrayBoxPre.push(filteredStaffRecords);
        if (isFilteredByArea)
            arrayBoxPre.push(filteredAreaRecords);
        if (isFilteredByDate)
            arrayBoxPre.push(filteredDateRecords);


        setArrayBox(arrayBoxPre);

    }, [filteredMountageRecords, filteredStaffRecords, filteredAreaRecords, filteredDateRecords, isFilteredByDate, isFilteredByArea, isFilteredByMountageState, isFilteredByStaff, firstDate, secondDate])





    useEffect(() => {

        if (arrayBox.length > 0) {
            setFilteredRecords(arrayBox.reduce((a, b) => a.filter(c => b.includes(c))));

        }
        else {
            setFilteredRecords(arrayBox);
        }
    }, [filteredMountageRecords, filteredStaffRecords, filteredAreaRecords, filteredDateRecords, arrayBox])


    /*

<iframe
        src={`${process.env.PUBLIC_URL}/map.html`}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="Interactive Map"
      />


    useEffect(() => {
  
        if(firstDate && secondDate){
            if(firstDate >= secondDate){
                //alert("Fazla ");
                //setDateIntervalArray([]);
                return;
            }
            else {
                let dates = [];
                let arr = [];
                ////console.log(moment(firstDate).diff(secondDate, "days"));
                ////console.log(moment(firstDate).format('DD.MM.YYYY')+" "+moment(firstDate).add(5, "days").format('DD.MM.YYYY')+" "+moment(secondDate).diff(firstDate, "days"));
                for(let i=0; i<moment(secondDate).diff(firstDate, "days"); i++)
                {
                    arr.push(propertiesOfSelectedRecords.filter(item => item.MONTAJTARIH == moment(firstDate).add(i, "days").format('DD.MM.YYYY').toString()).map(item => item));
                }
                setFilteredDateRecords(arr.flat());
                setIsFilteredByDate(true);
                ////console.log(arr.flat().filter(item => filteredRecords.includes(item)));
            }
        }
    }, [firstDate, secondDate]);
*/

    const bringMap = async (e) => {
        setBigDataModeForDropdown(false);
        if (e.target.value === "-1") {
            setIsMapTypeSelected(false);

        }
        else {
            setShowCanvas(true);
        }
        setIsMapTypeSelected(true);
        setMapType(e.target.value);

        setPath(`./../projects/${sp}/${e.target.value}.gpkg`);

        /*
        await axiosPrivateInstance.post('mergintransactions/handlewithmap', JSON.stringify({
            path: path
        })).then(res => //console.log(res)).catch(err => //console.error(err));
        */
    }


    useEffect(() => {
        if (mapNotification.visible) {
            const timer = setTimeout(() => {
                setMapNotification(prev => ({
                    ...prev,
                    visible: false
                }));
            }, 5000); // 5 saniye (5000 ms)

            return () => clearTimeout(timer); // Temizlik fonksiyonu
        }
    }, [mapNotification.visible]);



    useEffect(() => {
        //        setGeoData([]);
        if (isMapTypeSelected && mapType !== "-1") {
            /*

            */
            console.log("MAP IS BEING LOADED");
            setMapNotification(
                {
                    content: t("mapNotificationLoading"),
                    status: "WAIT",
                    visible: true
                }
            );
            axiosPrivateInstance.post('mergintransactions/doesmapexist', JSON.stringify({
                selected_project: sp,
                file_name: mapType
            })).then(resp => {
                if (!resp.data.doesExist) {
                    setPath(`./../projects/${sp}/${mapType}.gpkg`);
                    setPartialPath(`./../projects/${sp}`);
                    axiosPrivateInstance.post('mergintransactions/handlewithmap', JSON.stringify({
                        path: path,
                        partial_path: partialPath,
                        file_name: mapType,
                        selected_project: selectedProject
                    })).then(res => {
                        axiosPrivateInstance.post('mergintransactions/map', JSON.stringify({
                            selected_project: sp,
                            file_name: mapType
                        })).then(resp => {
                            //console.log(mapType + " " + path + " " + partialPath);
                            console.log("MAP IS READY");
                            setMapNotification(
                                {
                                    content: "",
                                    status: "EXP",
                                    visible: false
                                }
                            );
                            setGeoData(resp.data);

                        }).catch(err => {
                            console.log("ERROR");
                            setMapNotification(
                                {
                                    content: err.message,
                                    status: "ERR",
                                    visible: false
                                }
                            );
                            console.error(err);
                        });
                    }).catch(err => {
                        console.log("ERROR");
                        setMapNotification(
                            {
                                content: err.message,
                                status: "ERR",
                                visible: false
                            }
                        );
                        console.error(err);
                    });
                }
                else {
                    axiosPrivateInstance.post('mergintransactions/map', JSON.stringify({
                        selected_project: sp,
                        file_name: mapType
                    })).then(resp => {
                        console.log(mapType + " " + path + " " + partialPath);
                        console.log("MAP IS READY");
                        setMapNotification(
                            {
                                content: "",
                                status: "EXP",
                                visible: false

                            }
                        );
                        setGeoData(resp.data);
                    }).catch(err => {
                        console.log("ERROR");
                        setMapNotification(
                            {
                                content: err.message,
                                status: "ERR",
                                visible: true
                            }
                        );
                        console.error(err);
                    });
                }
            }).catch(err => {
                console.log("ERROR");
                setMapNotification(
                    {
                        content: err.message,
                        status: "ERR",
                        visible: false
                    }
                );
                console.log(err);
            });

            return () => setGeoData(null);
        }
    }, [mapType, isMapTypeSelected])


    useEffect(() => {
        let filenamesPre = [];
        //        setParentPath(`./../projects/${selectedProject}`);
        axiosPrivateInstance.post('mergintransactions/returnfilenames', JSON.stringify({
            path: `./../projects/${selectedProject}`
        })).then(res => {
            for (let i = 0; i < res.data.files.length; i++) {
                filenamesPre.push(res.data.files[i].replace('.gpkg', ''));
            }
            //setFiles(res.data);
            setFileNames(filenamesPre);
        }).catch(err => console.error(err));
    }, [selectedProject]);


    // loop in gpkg files. for now, print all of gpkg files in correct directory


    /*
    useEffect(() => {
      if(fileNames.length > 0){
          for(let i=0; i<fileNames.length; i++){
              let path = `./../projects/${selectedProject}/${fileNames[i]}.gpkg`;
            axiosPrivateInstance.post('mergintransactions/returnfilecontent', JSON.stringify({
                path: path
            })).then(res => {
                console.log("fileName ", fileNames[i]);
                console.log("path = ", path);
                console.log(res.data);
                          
                setAllOfItemsOfData([...allOfItemsOfData, {
                    fileName: fileNames[i]+'.gpkg',
                    data: res.data
                }])
                
            }).catch(err => {
                console.error(err);
            });
          }
      }
    }, [fileNames])
    */




    /*
    useEffect(() => {
        axiosPrivateInstance.post('mergintransactions/returnfilenames', JSON.stringify({
            path: path
        })).then(res => {
            //console.log(res.data);
            //setFiles(res.data);
        }).catch(err => //console.error(err));
    }, [path]);
    */
    /*
        useEffect(() => {
    //        showFrenchItems ? changeLanguage('fr') : changeLanguage('en');
        }, [showFrenchItems])
    */
    useEffect(() => {
        if (newMapOrGraph !== "-1") {
            setNewIsMapOrGraphSelected(true);
            setShowFilteredRecordsOnMap(false);

        }
        else {
            setNewIsMapOrGraphSelected(false);
            setMapType("-1");
            setGraphType("-1");
        }

    }, [newMapOrGraph])

    /*
        useEffect(() => {
            let path = `./../projects/${selectedProject}/${docType}.gpkg`;
            let fileName = `${docType}.gpkg`;
            axiosPrivateInstance.post('mergintransactions/filtergpkgfile', {
                path: path,
                filename: fileName,
                filtered_data: JSON.stringify(filteredRecords)
            }).then(res => console.log(res)).catch(err => console.log(err));
        }, [filteredRecords]);
    */



    /*
    useEffect(() => {
        let wanteds = [];
        setMapDataForSelectedRecords("");
        setShowFilteredRecordsOnMap(false);
        if (filteredRecords.length > 0) {
            let path = `./../projects/${selectedProject}/${docType}.gpkg`;
            axiosPrivateInstance.post('mergintransactions/returnfilecontent', JSON.stringify({
                path: path
            })).then(res => {
                console.log("SANKYONG");
                res.data.data[docType].features.map(allItems => {
                    filteredRecords.map(filteredItems => 
                    {
                        if(Object.keys(allItems.properties).length === Object.keys(filteredItems).length)
                        {
                            let desiredNumberOfEquity = Object.keys(allItems.properties).length;
                            let numberOfEqualKeys = 0;
                            for(let i=0; i<desiredNumberOfEquity; i++){
                                if(Object.keys(allItems.properties)[i] === Object.keys(filteredItems)[i] && allItems.properties[Object.keys(allItems.properties)[i]] === filteredItems[Object.keys(filteredItems)[i]]){
                                    numberOfEqualKeys++;
                                }
                            }
                            if(desiredNumberOfEquity === numberOfEqualKeys){
                                wanteds.push(allItems);
                            }
                        }
                    }
                    )  
                });

                res.data.data[docType].features = wanteds;
                
                setMapDataForSelectedRecords(res.data.data[docType]);
                
            }).catch(err => {
                console.error(err);
            });
        }
        
    }, [filteredRecords]);


    useEffect(() => {
        if(mapDataForSelectedRecords.features && mapDataForSelectedRecords.features.length > 0){
            setShowFilteredRecordsOnMapCheck(true);
        }
        else{
            setShowFilteredRecordsOnMapCheck(false);
        }
    }, [mapDataForSelectedRecords])

    useEffect(() => {
        setGeoData("");
        console.log("showFilteredRecordsOnMap => ", showFiltereRecordsOnMap);
        setGraphType("-1");
        setNewIsMapOrGraphSelected("-1");
        setNewIsMapOrGraphSelected("-1");
        setNewMapOrGraph("-1");
        console.log(mapDataForSelectedRecords);
    }, [showFiltereRecordsOnMap]);
    filtergpkgfile
*/

    useEffect(() => {

        setShowFilteredRecordsOnMap(false);
        setMapDataForSelectedRecords("");
    }, [filteredRecords])


    function chunkArray(array, chunkSize) {
        return array.reduce((result, item, index) => {
            const chunkIndex = Math.floor(index / chunkSize);
            if (!result[chunkIndex]) {
                result[chunkIndex] = []; // Yeni bir chunk oluştur
            }
            result[chunkIndex].push(item);
            return result;
        }, []);
    }



    /*
        useEffect(() => {
            if (showFiltereRecordsOnMap) {
            
                if(filteredRecords && filteredRecords.length <= 500)
                {
                //setNewMapOrGraph, setGraphType, setGraphData, setMapType
                setNewMapOrGraph("-1");
                let path = `./../projects/${selectedProject}/${docType}.gpkg`;
                let fileName = `${docType}.gpkg`;
                axiosPrivateInstance.post('mergintransactions/filtergpkgfile', {
                    path: path,
                    filename: fileName,
                    filtered_data: JSON.stringify(filteredRecords)
                }).then(res => {
                if(res.status == 200)
                {
                        console.log("ATTENTION");
                        console.log(res.data.data[docType]);
                    setMapDataForSelectedRecords(res.data.data[docType]);
                }
                	
                	
                	
                }).catch(async err => {
                    console.log(err);
                	
                    if(err.status == 413 || err.status == 500){
                            setPerformAdvancedFiltering(true);
    
            }
        	
                });
              }
              else if(filteredRecords && filteredRecords.length > 500){
                setPerformAdvancedFiltering(true);  
              }  
                
            }
            else{
                setPerformAdvancedFiltering(false);
            }
        }, [showFiltereRecordsOnMap])
        
        
        useEffect(() => {
        
            if(performAdvancedFiltering){
                let preConditions = {};
    
                    filteredRecords.map(item => {
                        
                        if(isFilteredByMountageState){
                        const matchingKey = Object.keys(item).find(key => key.includes("MONTAJDURU")) || Object.keys(item).find(key => key.includes("ÉTAT"));
                         if(matchingKey){
                            Object.assign(preConditions, {[matchingKey]: filterValue})
                         }
                       }
                       if(isFilteredByStaff){
                       const matchingKey = Object.keys(item).find(key => key.includes("MONTAJYAPA")) || Object.keys(item).find(key => key.includes("ASSEMBLEUR"));
                         if(matchingKey){
                            Object.assign(preConditions, {[matchingKey]: filterValueForStaff})
                         }
                       }
                       if(isFilteredByArea){
                       const matchingKey = Object.keys(item).find(key => key.includes("MAHALLE")) || Object.keys(item).find(key => key.includes("QUARTIERS"));
                         if(matchingKey){
                            Object.assign(preConditions, {[matchingKey]: areaValue})
                         }
                       }
                       if(isFilteredByDate){
                       const matchingKey = Object.keys(item).find(key => key.includes("MONTAJTARI")) || Object.keys(item).find(key => key.includes("HISTOIRE"));
                         if(matchingKey){
                            Object.assign(preConditions, {[matchingKey]: matchingKey, "firstDate": moment(firstDate).format("DD.MM.YYYY"), "secondDate": moment(secondDate).format("DD.MM.YYYY")})
                         }
                       }
                       
                    });
                if(showFiltereRecordsOnMap)
                {    
                    let path = `./../projects/${selectedProject}/${docType}.gpkg`;
                let fileName = `${docType}.gpkg`;
                  axiosPrivateInstance.post('mergintransactions/advancedfilter', {
                        path: path,
                        filename: fileName,
                        conditions: JSON.stringify(preConditions)
                    }).then(res => setMapDataForSelectedRecords( JSON.parse(res.data.saf) )).catch(err => console.log(err));   
                
            }
            }
        }, [performAdvancedFiltering, showFiltereRecordsOnMap]);
        */

    useEffect(() => {
        // Koşul sağlanıyorsa notification'ı güncelle
        if (newFirstDate && newSecondDate && !moment(newFirstDate).isBefore(newSecondDate)) {
            setTimeout(() => {
                setFilterNotification({
                    content: t("firstDateGreaterError"),
                    visible: true,
                    status: "ERROR"
                });
            }, 50);
            // Diğer state'leri de sıfırla
        }
    }, [newFirstDate, newSecondDate]);



    useEffect(() => {
        /*
    
                       */
        //	console.log("selectedRecords");
        //	console.log(selectedRecords);
        //setNewStaffValue
        //        newMountageState, newStaffValue, newAreaValue, newFirstDate, newSecondDate

        //setAbleToFilterWrtDate(true);
        setNewFilteredData({});
        setNewFilteredFeatures({});
        setShowFilteredRecordsOnMap(false);
        setMapDataForSelectedRecords("");
        let preConditions = {};

        selectedRecords.map(item => {
            /*
            if (newMountageState != "-1") {

                const matchingKey = Object.keys(item.properties).find(key => key.includes("MONTAJDURU")) || Object.keys(item.properties).find(key => key.includes("ÉTAT"));
                if (matchingKey) {
                    Object.assign(preConditions, { [matchingKey]: newMountageState })
                }
            }
            */
            
            if (newMountageState != "-1") {

    const matchingKey = Object.keys(item.properties).find(key => key.includes("MONTAJDURU")) || Object.keys(item.properties).find(key => key.includes("ÉTAT"));
    if (matchingKey) {
        const mountageStateAliases = {
            "1": ["1", "TAKILACAK"],
            "2": ["2", "TAKILDI"],
            "3": ["3", "TAKILAMADI"]
        };
        const mountageStateValue = mountageStateAliases[newMountageState] || [newMountageState];
        Object.assign(preConditions, { [matchingKey]: mountageStateValue })
    }
}
            
            if (newStaffValue != "-1") {
                const matchingKey = Object.keys(item.properties).find(key => key.includes("MONTAJYAPA")) || Object.keys(item.properties).find(key => key.includes("ILKMONTAJ")) || Object.keys(item.properties).find(key => key.includes("INSTALLATEUR"));
                if (matchingKey) {
                    Object.assign(preConditions, { [matchingKey]: newStaffValue })
                }
            }
            if (newAreaValue != "-1") {
                const matchingKey = Object.keys(item.properties).find(key => key.includes("MAHALLE")) || Object.keys(item.properties).find(key => key.includes("MAHALLE_")) || Object.keys(item.properties).find(key => key.includes("QUARTIER"));
                if (matchingKey) {
                    Object.assign(preConditions, { [matchingKey]: newAreaValue })
                }
            }


            if (newFirstDate && newSecondDate && moment.isDate(newFirstDate) && moment.isDate(newSecondDate) &&
                moment(new Date(newFirstDate)).format('DD.MM.YYYY').length == 10 && moment(new Date(newSecondDate)).format('DD.MM.YYYY').length == 10


            ) {
                const matchingKey = Object.keys(item.properties).find(key => key.includes("MONTAJTARI")) || Object.keys(item.properties).find(key => key.includes("MONTAJTAR_")) || Object.keys(item.properties).find(key => key.includes("HISTOIRE"));
                if (matchingKey) {
                    Object.assign(preConditions, { [matchingKey]: matchingKey, "firstDate": moment(newFirstDate).format("DD.MM.YYYY"), "secondDate": moment(newSecondDate).format("DD.MM.YYYY") })
                }
            }

        });

        let filterableWrtDate = (moment(newFirstDate).format('DD.MM.YYYY').length != 10 && moment(newSecondDate).format('DD.MM.YYYY').length != 10) || (newFirstDate && newSecondDate &&
            moment(newFirstDate).isValid() && moment(newSecondDate).isValid() && moment(newFirstDate).isBefore(newSecondDate));

        if (newFirstDate && newSecondDate && !moment(newFirstDate).isBefore(newSecondDate)) {


            setNewFirstDate("");
            setNewSecondDate("");
            setIsFilteredByDate(false);
        }
        else if (newFirstDate && newSecondDate && moment(newFirstDate).isBefore(newSecondDate) && filterableWrtDate) {
            setIsFilteredByDate(true);

        }

        if (typeof preConditions == "object" && Object.keys(preConditions).length > 0 && filterableWrtDate
        ) {

            setIsFilterGroupDisabled(true);
            let path = `./../projects/${selectedProject}/${docType}.gpkg`;
            let fileName = `${docType}.gpkg`;
            console.log("preConditions");
            console.log(preConditions)
            setConditions(preConditions);


            /*    
                  axiosPrivateInstance.post('mergintransactions/advancedfilter', {
                        path: path,
                        filename: fileName,
                        conditions: JSON.stringify(preConditions)
                    }).then(res => {
                            setFilterNotification({
                    content: "",
                    visible: false,
                    status: "",
                    willFadeOut: false
                    })
    //            		console.log(res);
                setIsFilterGroupDisabled(false);
                        setNewFilteredData(res.data);
                        setNewFilteredFeatures(JSON.parse(res.data.saf));
                    }).catch(err => {
                        console.log(err); 
                        setIsFilterGroupDisabled(false); 
                        setFilterNotification({
                content: "ERROR OCCURED",
                visible: true,
                status: "ERROR",
                willFadeOut: true
                })
                        
                        })
                        */

            let retryCount = 0;
            const maxRetries = 5;

            const executeRequest = () => {
                setFilterNotification({
                    content: t('filterNotificationInProgress'),
                    visible: true,
                    status: "WAIT"
                })

                axiosPrivateInstance.post('mergintransactions/advancedfilter', {
                    path: path,
                    filename: fileName,
                    conditions: JSON.stringify(preConditions)
                }).then(res => {
                    setFilterNotification({
                        content: "",
                        visible: false,
                        status: ""
                    });
                    setIsFilterGroupDisabled(false);
                    setNewFilteredData(res.data);
                    setNewFilteredFeatures(JSON.parse(res.data.saf));
                }).catch(err => {
                    console.log(err);
                    retryCount++;

                    if (retryCount < maxRetries) {
                        setTimeout(executeRequest, 1000); // 1 saniye sonra tekrar dene
                    } else {
                        setIsFilterGroupDisabled(false);
                        setFilterNotification({
                            content: t('filterNotificationErrorOccured'),
                            visible: true,
                            status: "ERROR"
                        });
                    }
                });
            };

            // İlk isteği tetikle
            executeRequest();
        }







    }, [newMountageState, newStaffValue, newAreaValue, newFirstDate, newSecondDate, selectedRecords, docType]);





    /*
    useEffect(() => {
        if(showFiltereRecordsOnMap){
            setBigDataModeForCheckBox(false);
            setMapDataForSelectedRecords(newFilteredFeatures);
            setNewMapOrGraph("-1");
            setMapType("-1");

            //newMapOrGraph === "map" && mapType !== "-1"

        }
        else{
            setMapDataForSelectedRecords("");
        }
    }, [showFiltereRecordsOnMap])
    */
    useEffect(() => {
        if (showFiltereRecordsOnMap) {
            setBigDataModeForCheckBox(false);

            // 1. Yükleme başladı
            console.log("MAP IS BEING LOADED");
            setMapNotification({
                content: t("mapNotificationLoading"),
                status: "WAIT",
                visible: true
            });

            // 2. Veriyi güncelle (mevcut mantık)
            setMapDataForSelectedRecords(newFilteredFeatures);

            setNewMapOrGraph("-1");
            setMapType("-1");

            // 3. Yükleme bitince state'i güncelle (timeout veya useEffect ile)
            const timer = setTimeout(() => {

                console.log("Harita hazır!");
                setMapNotification({
                    content: "MAP IS READY",
                    status: "EXP",
                    visible: false
                });

            }, 0);

            return () => clearTimeout(timer); // Cleanup
        } else {

            setMapDataForSelectedRecords("");
        }
    }, [showFiltereRecordsOnMap, newFilteredFeatures]);


    useEffect(() => {
        if (mapDataForSelectedRecords.features && mapDataForSelectedRecords.features.length > 5000) {
            setMapDataForSelectedRecords({
                ...mapDataForSelectedRecords,
                features: mapDataForSelectedRecords.features.slice(0, 50)
            });
            setBigDataModeForCheckBox(true);
        }
        else if (mapDataForSelectedRecords.features && mapDataForSelectedRecords.features.length <= 5000) {
            setBigDataModeForCheckBox(true);
        }
    }, [mapDataForSelectedRecords])

    useEffect(() => {
        if (geoData && geoData.features && geoData.features.length > 5000) {
            setGeoData({
                ...geoData,
                features: geoData.features.slice(0, 50)
            });
            setBigDataModeForDropdown(true);
        }
        else if (geoData && geoData.features && geoData.features.length <= 5000) {
            setBigDataModeForDropdown(true);
        }
    }, [geoData]);


    const exportToExcel = (data, fileName) => {
        let newData = data.map(item => item.properties);
        const worksheet = XLSX.utils.json_to_sheet(newData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Generate a blob for the file and trigger download
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const exportToCSV = (data, fileName) => {
        let newData = data.map(item => item.properties);
        const headers = Object.keys(newData[0]).join(','); // Extract headers
        const rows = newData.map(row => Object.values(row).join(',')); // Extract rows
        const csv = [headers, ...rows].join('\n'); // Combine headers and rows

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    useEffect(() => {
        console.log("MapNot");
        console.log(mapNotification);
        console.log(mapNotification && mapNotification.visible);
    }
        , [mapNotification])



    return (
        <>

            <div id={styles.mainFrame}>
                <div id={styles.dailyAndTotal} className='col-sm col-xs col-md'>
                    {
                        files.files && (files.files.includes("PLAQUES_POTEAU.gpkg") || files.files.includes("PLAQUES_MURALES.gpkg") || files.files.includes("POTEAU.gpkg")) ?
                            <div id={styles.showForeignRecords}>
                                <button type="button" class="btn btn-danger" data-bs-toggle="button" onClick={() => {
                                    setShowFrenchItems(!showFrenchItems);
                                    setShowCanvas(false);


                                }}>{showFrenchItems ? "AFFICHER LES ARTICLES EN ANGLAIS" : t('showAndFilterFrenchItems')}</button>
                            </div> : ""
                    }

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "AUJOURD’HUI" : t('todayCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Sur Poteau Installée" : t('enhancedSubDashboardMountedDoorToday')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && plaquesPoteauTod ? plaquesPoteauTod : numberOfMountedDoorTod}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "AUJOURD’HUI" : t('todayCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Murale Installée" : t('enhancedSubDashboardMountedPoleToday')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && plaquesMuralesTod ? plaquesMuralesTod : numberOfMountedPoleTod}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "AUJOURD’HUI" : t('todayCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Poteau Installé" : t('enhancedSubDashboardMountedWallToday')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && poteauTod ? poteauTod : numberOfMountedWallTod}</h1>
                    </div>


                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "HIER" : t('yesterdayCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Sur Poteau Installée" : t('enhancedSubDashboardMountedDoorYesterday')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && plaquesPoteauYest ? plaquesPoteauYest : numberOfMountedDoorYest}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "HIER" : t('yesterdayCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Murale Installée" : t('enhancedSubDashboardMountedPoleYesterday')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && plaquesMuralesYest ? plaquesMuralesYest : numberOfMountedPoleYest}</h1>
                    </div>
                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "HIER" : t('yesterdayCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Poteau Installé" : t('enhancedSubDashboardMountedWallYesterday')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && poteauYest ? poteauYest : numberOfMountedWallYest}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "TOTAL" : t('totalCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Sur Poteau Installée" : t('enhancedSubDashboardTotalMountedDoor')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && (mountedPlaquesPoteau.length > 0 || editedPlaquesPoteau.length > 0) ? mountedPlaquesPoteau.length + editedPlaquesPoteau.length : mountedDoors.length > 0 || editedDoors.length > 0 ? mountedDoors.length + editedDoors.length : 0}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "TOTAL" : t('totalCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Murale Installée" : t('enhancedSubDashboardTotalMountedPole')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && (mountedPlaquesMurales.length > 0 || editedPlaquesMurales.length > 0) ? mountedPlaquesMurales.length + editedPlaquesMurales.length : mountedPoles.length > 0 || editedPoles.length > 0 ? mountedPoles.length + editedPoles.length : 0}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "TOTAL" : t('totalCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Poteau Installé" : t('enhancedSubDashboardTotalMountedWall')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && (mountedPoteau.length > 0 || editedPoteau.length > 0) ? mountedPoteau.length + editedPoteau.length : mountedWalls.length > 0 || editedWalls.length > 0 ? mountedWalls.length + editedWalls.length : 0}</h1>
                    </div>


                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "NON INSTALLÉ" : t('notMountedCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Sur Poteau" : t('enhancedSubDashboardNotMountedDoors')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && notMountedPlaquesPoteau ? notMountedPlaquesPoteau.length : notMountedDoors.length}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "NON INSTALLÉ" : t('notMountedCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Murale" : t('enhancedSubDashboardNotMountedPoles')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && notMountedPlaquesMurales ? notMountedPlaquesMurales.length : notMountedPoles.length}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "NON INSTALLÉ" : t('notMountedCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Poteau" : t('enhancedSubDashboardNotMountedWalls')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && notMountedPoteau ? notMountedPoteau.length : notMountedWalls.length}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "À INSTALLER" : t('willBeMountedCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Sur Poteau" : t('enhancedSubDashboardWillBeMountedDoors')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && willBeMountedPlaquesPoteau ? willBeMountedPlaquesPoteau.length : willBeMountedDoors.length}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "À INSTALLER" : t('willBeMountedCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Plaque Murale" : t('enhancedSubDashboardWillBeMountedPoles')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && willBeMountedPlaquesMurales ? willBeMountedPlaquesMurales.length : willBeMountedPoles.length}</h1>
                    </div>

                    <div id={styles.childOfDailyAndTotal}>
                        <b className="fs-6 text-danger">{showFrenchItems ? "À INSTALLER" : t('willBeMountedCaption')}</b>
                        <p className='fs-6 text-dark' id={styles.innerLeftestCaption}>{showFrenchItems ? "Poteau" : t('enhancedSubDashboardWillBeMountedWalls')}</p>
                        <h1 className="text-dark" id={styles.innerLeftValue}>{showFrenchItems && willBeMountedPoteau ? willBeMountedPoteau.length : willBeMountedWalls.length}</h1>
                    </div>
                </div>


                <div id={styles.mapFrame}>
                    <div id={styles.mapInfo}>





                        <b className='fs-5 text-dark'>{t('enhancedSubDashboardMapOrGraph')}</b>
                        <select onChange={(e) => setNewMapOrGraph(e.target.value)} id={styles.mapOrGraph} value={newMapOrGraph} className='form-select mx-1 border border-danger' style={{ marginRight: '5px', padding: '5px' }}>
                            <option value="-1">{newIsMapOrGraphSelected ? t('clearSelection') : t('enhancedSubDashboardPleaseSelect')}</option>
                            <option value="map">{t('enhancedSubDashboardMap')}</option>
                            <option value="graph">{t('enhancedSubDashboardGraph')}</option>
                        </select>


                        {newMapOrGraph !== "-1" ?
                            newMapOrGraph === "map" ?

                                <>
                                    <div id={styles.mapButtonBox}>
                                        <b className="fs-5 text-dark">{t('enhancedSubDashboardMapTransactions')}</b>
                                        <select onChange={(e) => { setMapType(e.target.value); bringMap(e) }} value={mapType} className='form-select mx-1 border border-danger' id={styles.setTypeOfGraph} style={{ marginBottom: '15px', marginRight: '5px', padding: '5px' }}>
                                            <option value="-1" selected>{t('enhancedSubDashboardPleaseMakeSelection')}</option>
                                            {
                                                fileNames.map(item => {
                                                    return (
                                                        <option value={item}>{item}</option>
                                                    )
                                                })
                                            }


                                        </select>
                                    </div>
                                </>



                                :
                                <>
                                    <b className='fs-5 text-dark'>{t('enhancedSubDashboardGraphTransactions')}</b>
                                    <select onChange={(e) => setGraphType(e.target.value)} value={graphType} className="form-select mx-1 border border-danger" id={styles.setTypeOfGraph} style={{ marginRight: '5px', padding: '5px' }}>

                                        {
                                            showFrenchItems ?
                                                <>
                                                    <option value="-1" selected>Veuillez sélectionner le type de graphique</option>
                                                    <option value="overallplqpot">Tableau de l'état des plaques postales (graphique à barres)</option>
                                                    <option value="overallplqmur">Tableau de l'état des plaques murales (graphique à barres)</option>
                                                    <option value="overallpoteau">Tableau de l'état des poteau (graphique à barres)</option>
                                                    <option value="poverallplqpot">Tableau de l'état des plaques postales (diagramme circulaire)</option>
                                                    <option value="poverallplqmur">Tableau de l'état des plaques murales (diagramme circulaire)</option>
                                                    <option value="poverallpoteau">Tableau de l'état des poteau (diagramme circulaire)</option>
                                                </>
                                                :
                                                <>
                                                    <option value="-1" selected>{t('enhancedSubDashboardPleaseMakeSelection')}</option>
                                                    <option value="overalldoor">{t('enhancedSubDashboardOverAllDoor')}</option>
                                                    <option value="overallwall">{t('enhancedSubDashboardOverAllWall')}</option>
                                                    <option value="overallpole">{t('enhancedSubDashboardOverAllPole')}</option>
                                                    <option value="poveralldoor">{t('enhancedSubDashboardPoverAllDoor')}</option>
                                                    <option value="poverallwall">{t('enhancedSubDashboardPoverAllWall')}</option>
                                                    <option value="poverallpole">{t('enhancedSubDashboardPoverAllPole')}</option>
                                                </>
                                        }
                                    </select>
                                </>
                            : ""}










                    </div>

                    <div className='px-3 py-2'>
                        {
                            newMapOrGraph === "graph" && graphType !== "-1" ?

                                graphForm === "barchart" ?
                                    <BarChart data={graphData} id={styles.barChart} /> :
                                    <PieChart data={graphData} id={styles.barChart} />

                                : newMapOrGraph === "map" && mapType !== "-1" && showFiltereRecordsOnMap !== true ?


                                    (geoData && bigDataModeForDropdown) ?
                                        (mapNotification && mapNotification.content > 0) ? <div className={mapNotification.status == "WAIT" ? "alert alert-success" : "alert alert-danger"}>{mapNotification.content}</div> :
                                            <MapView geojsonData={geoData} mapType={mapType} selectedProject={selectedProject} selectedNamespace={selectedNamespace} /> :
                                        (mapNotification.content && mapNotification.content.length > 0 && mapNotification.visible) ? <div className={mapNotification.status == "WAIT" ? "alert alert-success" : "alert alert-danger"}>{mapNotification.content}</div> : ""


                                    : showFiltereRecordsOnMap === true && mapDataForSelectedRecords.features && mapDataForSelectedRecords.features.length && mapDataForSelectedRecords.features.length > 0 && bigDataModeForCheckBox ?

                                        (mapNotification && mapNotification.content > 0) ? <div className={mapNotification.status == "WAIT" ? "alert alert-success" : "alert alert-danger"}>{mapNotification.content}</div> :
                                            <MapView geojsonData={mapDataForSelectedRecords} mapType={docType} selectedProject={selectedProject} selectedNamespace={selectedNamespace} conditions={conditions} />
                                        : (mapNotification.content && mapNotification.content.length > 0 && mapNotification.visible) ? <div className={mapNotification.status == "WAIT" ? "alert alert-success" : "alert alert-danger"}>{mapNotification.content}</div> : ""

                        }
                    </div>



                </div>

                <div id={styles.rightestOuter}>




                    <div className="border-top border-start">


                        <div className="jumbotron jumbotron-fluid border border-light rounded bg-danger my-3">
                            <b className="fs-5 text-light" >{t("rightestFilterCaption")}</b>
                        </div>




                        {fileNames.map((item, index) => (
                            <div className="border-end border-bottom p-2 bg-transparent" key={index}>
                                <div className="form-check h-100">

                                    <input
                                        className="form-check-input d-none"
                                        type="radio"
                                        name="exampleRadios"
                                        id={`exampleRadios${index}`}
                                        value={item}
                                        onClick={(e) => handleTypeSelection(e)}
                                    />
                                    <label
                                        className="form-check-label w-100 d-block p-2 text-truncate"
                                        htmlFor={`exampleRadios${index}`}
                                        style={{
                                            backgroundColor: 'transparent',
                                            transition: 'background-color 0.2s',
                                            cursor: 'pointer',
                                            display: 'block',
                                            width: '100%',
                                            padding: '0.5rem',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            ...(document.querySelector(`#exampleRadios${index}`)?.checked ? {
                                                backgroundColor: 'rgba(220, 53, 69, 0.1)',
                                                fontWeight: 'bold'
                                            } : {})
                                        }}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)'}
                                        onMouseOut={(e) => {
                                            const radio = document.querySelector(`#exampleRadios${index}`);
                                            e.currentTarget.style.backgroundColor = radio?.checked
                                                ? 'rgba(220, 53, 69, 0.1)'
                                                : 'transparent';
                                        }}
                                    >
                                        {item}
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>





                    {
                        isDocTypeSelected ?
                            <>
                                <div id={styles.recordListBar} className='bg-light my-3 border border-danger rounded'>
                                    <table className='table table-fluid'>
                                        <tr>
                                            <th>{t('mountageState')}</th>
                                            <td>{newMountageState && newMountageState !== "-1" ? parseMountageState(newMountageState) : "-"}</td>
                                        </tr>

                                        <tr>
                                            <th>{t('fieldStaff')}</th>
                                            <td>{newStaffValue && newStaffValue !== "-1" ? parseStaffValue(newStaffValue) : "-"}</td>
                                        </tr>
                                        <tr>
                                            <th>{t('neighbourhood')}</th>
                                            <td>{newAreaValue && newAreaValue !== "-1" ? parseAreaValue(newAreaValue) : "-"}</td>
                                        </tr>
                                        <tr>
                                            <th>{t('dateInterval')}</th>
                                            <td>{moment.isDate(newFirstDate) && moment.isDate(newSecondDate) ? `${moment(newFirstDate).format('DD.MM.YYYY').toString()} - ${moment(newSecondDate).format('DD.MM.YYYY')}` : ""}</td>
                                        </tr>
                                        <tr>
                                            <th>{t('numberOfRecords')}</th>
                                            <td>{newFilteredFeatures.features ? newFilteredFeatures.features.length : 0}</td>
                                        </tr>

                                    </table>

                                </div>


                                <div id={styles.recordList} className='border border-danger rounded container-fluid'>

                                    {
                                        newFilteredFeatures.features && newFilteredFeatures.features.map(item => {
                                            return (
                                                <>
                                                    <hr />
                                                    <div className="row align-items-center">
                                                        <div className="col-3 text-nowrap">
                                                            <b className="text-danger">{t('district')}</b>
                                                        </div>
                                                        <div className="col-9 text-end">
                                                            <p className="mb-0">{item.properties && item.properties.ILCE ? item.properties.ILCE : item.properties.COMMUNE ? item.properties.COMMUNE : ""}</p>
                                                        </div>
                                                    </div>

                                                    <div className="row align-items-center">
                                                        <div className="col-3 text-nowrap">
                                                            <b className="text-danger">{t('neighbourhood')}</b>
                                                        </div>
                                                        <div className="col-9 text-end">
                                                            <p className="mb-0">{item.properties && item.properties.MAHALLE ? item.properties.MAHALLE : item.properties.QUARTIERS ? item.properties.QUARTIERS : item.properties.MAHALLE_ ? item.properties.MAHALLE_ : item.properties.MAHALLE_1}</p>
                                                        </div>
                                                    </div>

                                                    <div className="row align-items-center">
                                                        <div className="col-3 text-nowrap">
                                                            <b className="text-danger">{t('assemblyPersonel')}</b>
                                                        </div>
                                                        <div className="col-9 text-end"><p className="mb-0">{item.properties && item.properties.MONTAJYAPA ? item.properties.MONTAJYAPA : item.properties.INSTALLATEUR ? item.properties.INSTALLATEUR : item.properties.ILKMONTAJ ? item.properties.ILKMONTAJ : "" }</p>
                                                        </div>
                                                    </div>


                                                    <div className="row align-items-center">
                                                        <div className="col-3 text-nowrap">
                                                            <b className="text-danger">{t('mountageState')}</b>
                                                        </div>
                                                        <div className="col-9 text-end">
                                                            <p className="mb-0">{item.properties && (item.properties.MONTAJDURUM || item.properties.MONTAJDURU) ? parseMountageState(item.properties.MONTAJDURUM ?? item.properties.MONTAJDURU ?? filterWrtMountageState) : parseMountageState(item.properties.ÉTAT)}</p>

                                                        </div>
                                                    </div>

                                                    <div className="row align-items-center">
                                                        <div className="col-3 text-nowrap">
                                                            <b className="text-danger">{t('installationDateTime')}</b>
                                                        </div>
                                                        <div className="col-9 text-end">
                                                            <p className="mb-0">{item.properties && item.properties.MONTAJTARIH ? item.properties.MONTAJTARIH : item.properties.HISTOIRE ? item.properties.HISTOIRE : item.properties.MONTAJTARI ? item.properties.MONTAJTAR_ : "" }/{item.properties && item.properties.MONTAJSAAT ? item.properties.MONTAJSAAT : item.properties.HEURES ? item.properties.HEURES : ""}</p>

                                                        </div>
                                                    </div>



                                                    <hr />
                                                </>
                                            )
                                        })
                                    }
                                </div>

                                {
                                    filterNotification && filterNotification.visible ?
                                        <div className={filterNotification.status == "WAIT" ? "alert alert-primary my-2" : "alert alert-danger my-2"}>
                                            {filterNotification.content}
                                        </div> : ""
                                }









                                <b>{t('mountageStateFilter')}</b>
                                <div id={styles.recordListBar}>


                                    <select onChange={(e) => setNewMountageState(e.target.value)} value={newMountageState} className="form-select border border-danger" disabled={isFilterGroupDisabled}>
                                        <option value="-1" selected>{t('mountageStateFilter')}</option>
                                        <option value={showFrenchItems ? "À installer" : "1"}>{t('willBeMounted')}</option>
                                        <option value={showFrenchItems ? "Installé" : "2"}>{t('mounted')}</option>
                                        <option value={showFrenchItems ? "Non installé" : "3"}>{t('notMounted')}</option>
                                    </select>

                                </div>
                                <b>{t('staffFilter')}</b>
                                <div id={styles.recordListBar}>


                                    <select onChange={(e) => setNewStaffValue(e.target.value)} value={newStaffValue} className='form-select border border-danger' disabled={isFilterGroupDisabled}>
                                        <option value="-1" selected>{t('staffFilter')}</option>
                                        {stuffForSelectedRecords && stuffForSelectedRecords.map(item => {
                                            return (<option value={item}>{item}</option>)
                                        })}
                                    </select>
                                </div>

                                <b>{t('districtFilter')}</b>
                                <div id={styles.recordListBar}>
                                    <select onChange={(e) => setNewAreaValue(e.target.value)} value={newAreaValue} className='form-select border border-danger' disabled={isFilterGroupDisabled}>
                                        <option value="-1" selected>{t('districtFilter')}</option>
                                        {areas && areas.map(item => {
                                            return (<option value={item}>{item}</option>)
                                        })}
                                    </select>
                                </div>
                                <b>{t('dateFilter')}</b>

                                <div id={styles.recordListBarOpaque}>
                                    <DatePicker selected={newFirstDate} value={newFirstDate} onChange={(date) => setNewFirstDate(date)} id={styles.datepicker} placeholderText={t('pickFirstDate')} className="border border-danger" disabled={isFilterGroupDisabled} />
                                </div>
                                <div id={styles.recordListBarOpaque}>
                                    <DatePicker selected={newSecondDate} value={newSecondDate} onChange={(date) => {
                                        setNewSecondDate(date);


                                    }} id={styles.datepicker} placeholderText={t('pickSecondDate')} className="border border-danger" disabled={isFilterGroupDisabled} />


                                </div>






                                {
                                    newFilteredFeatures.features && newFilteredFeatures.features.length > 0 ?
                                        <div className='col-xs col-sm col-md col-lg'>
                                            <div className="form-check m-0 p-0 d-flex flex-column">
                                                <label className='fs-5 text-dark mb-2' htmlFor="showFilteredDataOnMap">
                                                    <input
                                                        type="checkbox"
                                                        value={showFiltereRecordsOnMap}
                                                        checked={showFiltereRecordsOnMap}
                                                        onChange={() => setShowFilteredRecordsOnMap(!showFiltereRecordsOnMap)}
                                                    />
                                                    <span className="mx-1"></span>
                                                    {t('showOnMap')}
                                                </label>
                                                {showFiltereRecordsOnMap ? <h6 className="text-dark">{notificationForLoadingOfMapData}</h6> : ""}
                                                <button onClick={() => exportToExcel(newFilteredFeatures.features, `${selectedProject}_${docType}`)} className='btn btn-sm btn-danger m-2 p-2'>
                                                    <FontAwesomeIcon icon={faFileExcel} style={{ marginRight: '8px', color: 'green' }} />
                                                    {t('exportToExcel')}
                                                </button>

                                                <button onClick={() => exportToCSV(newFilteredFeatures.features, `${selectedProject}_${docType}`)} className='btn btn-sm btn-danger m-2 p-2'>
                                                    <FontAwesomeIcon icon={faFileCsv} style={{ marginRight: '8px', color: 'green' }} />
                                                    {t('exportToCsv')}
                                                </button>


                                            </div>
                                        </div>

                                        : ""
                                }

                            </>
                            : ""
                    }

                </div>

            </div>

        </>
    )
}

export default EnhancedSubDashboard;
